import React, { useState, useEffect, useCallback, useRef } from "react"
import {
  Container,
  Button,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Label,
  Input,
  Form,
  FormFeedback,
} from "reactstrap"

import "react-multi-carousel/lib/styles.css"

import { Link, useParams, useLocation, useNavigate } from "react-router-dom"
import { SECURITY_KEY, BASE_URL } from "../../global"
import awicon from "../../assets/images/services-icon/coin.png"
import Select from "react-select"

// Formik validation
import * as Yup from "yup"
import { useFormik } from "formik"

//i18n
import axios from "axios"

import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"


import Loader from "react-spinner-loader"

import { MathJax, MathJaxContext } from "better-react-mathjax"

import { Popover, UncontrolledPopover, PopoverBody } from "reactstrap"
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
} from "reactstrap"
import { Table } from "reactstrap"

import { useOverlayOptions, OverlayUI, OverlayToggleButton, OVERLAY_FONTS, getKeyStage, getFontFamily } from "../Utility/OverlayOptions";

import { SpeakerButton, useSpeaker, htmlToText, ResultSpeakButton, isYearOneToThree  } from "../Utility/Usespeaker"
/* ─── helper: render the pill content for any question_status ─── */
function renderNavContent(question_status, label) {
  switch (question_status) {
    case 3:
      return (
        <>
         <i className="mdi mdi-close-thick font-size-20" style={{ color: "#e53935" }}></i>
        </>
      )
    case 4:
      return (
        <>
         <i className="fas fa-check font-size-16" style={{ color: "#43a047" }}></i>
        </>
      )
    case 5:
      return (
        <>
           <i className="fas fa-check font-size-16" style={{ color: "#fb8c00" }}></i>
        </>
      )
    default:
      return (
        <span className="font-size-20 fw-bold">{label}</span>
      )
  }
}

/* ─── helper: resolve className for the NavLink pill ─── */
function resolveNavClass(question_status, isActiveTab) {
  //if (isActiveTab) return "active "
  switch (question_status) {
    case 1:  return " display-hold_active"
    case 2:  return " display-number"
    case 3:  return " display-attempt_fail"
    case 4:  return " display-attempt1"
    case 5:  return " display-attempt2"
    default: return " display-number"
  }
}


const AssessmentDetails = React.memo(() => {
  const { key } = useParams()

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const type = searchParams.get("type") || null
  const homework = searchParams.get("homework") || null

  const question_no = searchParams.get("question_no") || 1

  let pk_activity_key = null
  let IsType = null
  let IsHomework = null
  let IsQuestionNo = 1
  if (
    key &&
    key.length >= 16 &&
    type &&
    type != null &&
    homework &&
    homework != null
  ) {
    pk_activity_key = key
    IsType = type
    IsHomework = homework
    IsQuestionNo = question_no
  } else {
    window.history.back()
  }

  //common
  const { speak, stop, activeId } = useSpeaker()
  const [loader, setLoader] = useState(false)
  const [ActivityData, setActivityData] = useState([])
  const [TopicData, setTopicData] = useState(null)

  // console.log(otherData);
  const authUser = JSON.parse(localStorage.getItem("authStudentUser")) || null

  const navigate = useNavigate()
  useEffect(() => {
    fetchData()
  }, [location])

  const fetchData = async () => {
    if (authUser && authUser != "" && authUser != null) {
      if (pk_activity_key && pk_activity_key != null && pk_activity_key != "") {
        setLoader(true)
        setActivityData([])
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "studentSession/StudentAssessmentQuestions", {
            pk_activity_key: pk_activity_key,
            subject_id: type,
          })
          .then(responseActivity => {
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            setLoader(false)

            if (responseActivity.data.LessonActivitiesQuestions.length > 0) {
              setActivityData(responseActivity.data)
              const topicNames = responseActivity.data.topics
                .flat()
                .map(obj => obj.topic_name)
              const mergedTopics = topicNames.join(", ")
              //console.log(mergedTopics);
              setTopicData(mergedTopics)
            } else {
              setActivityData([])
              setTopicData(null)
            }
          })
          .catch(error => {
            setLoader(false)
            if (
              (error?.response?.status === 403 ||
                error?.response?.status === 401) &&
              (error?.response?.data?.error === "jwt expired" ||
                error?.response?.data?.error === "invalid algorithm" ||
                error?.response?.data?.error === "invalid token")
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setLoader(false)
        window.history.back()
      }
    } else {
      // setLoader(false);
      navigate("/login")
    }
  }

  // const CountTotalCoins = question => {
  //   let total_coins = 0;

  //   if (question && question.length > 0) {
  //       question.forEach(activity => {
  //           if (activity.fk_sub_id === '1') {
  //               total_coins += activity.english_question.length * 2;
  //           } else if (activity.fk_sub_id === '2' || activity.fk_sub_id === '3') {
  //               total_coins += activity.question.length * 2;
  //           }
  //       });
  //   }
  //  // setTotalCoins(total_coins);
  //   return total_coins;
  // };

  const CountTotalCoins = question => {
    let total_coins = 0

    if (question && question.length > 0) {
      question.forEach(activity => {
        if (activity.fk_sub_id === "1") {
          if (
            activity.english_question &&
            (parseInt(
              activity.english_question[0]?.english_question_category_id
            ) === 10 ||
              parseInt(
                activity.english_question[0]?.english_question_category_id
              ) === 13)
          ) {
            activity.english_question.map((question, index1) => {
              let total_part = question.english_question_parts
              let array_part_data = total_part.filter(
                part =>
                  part.english_question_answers?.length > 0 &&
                  part.english_question_answers[0]?.english_answer_text &&
                  part.english_question_answers[0]?.english_answer_text != ""
              )
              total_coins += array_part_data.length * 2 || 0
            })
          } else {
            total_coins += activity?.english_question?.reduce(
              (acc, question) =>
                acc + question?.english_question_parts?.length * 2,
              0
            )
          }
          // total_coins += activity.english_question.reduce((acc, question) => acc + question.english_question_parts.length * 2, 0);
        } else if (activity.fk_sub_id === "2" || activity.fk_sub_id === "3") {
          total_coins += activity?.question?.reduce(
            (acc, question) => acc + question?.question_parts?.length * 2,
            0
          )
        }
      })
    }
    // setTotalCoins(total_coins);
    return total_coins
  }

  // useEffect(() => {

  // if(ActivityData && ActivityData.activity_node && ActivityData.activity_node.length > 0){
  //   setTopicData(ActivityData.activity_node[0]);
  // }else{
  //   setTopicData(null)
  // }

  // }, [ActivityData, key])

  //const timerValue = TimerComponent(); // Get timer value from TimerComponent

  // ===== Overlay Options (color tint / font-size / intensity) — self-contained =====
   const [overlayPanelOpen, setOverlayPanelOpen] = useState(false)
    const overlayAnchorRef = useRef(null)
    const [overlayPanelPos, setOverlayPanelPos] = useState({ top: 0, right: 0 })
    useEffect(() => {
      if (!overlayPanelOpen) return
      function handleResize() {
        if (overlayAnchorRef.current) {
          const rect = overlayAnchorRef.current.getBoundingClientRect()
          setOverlayPanelPos({
            top: rect.bottom - 60,
            right: window.innerWidth - rect.right,
            maxHeight: window.innerHeight - (rect.bottom - 60) - 16,
          })
        }
      }
      window.addEventListener("resize", handleResize)
      return () => window.removeEventListener("resize", handleResize)
    }, [overlayPanelOpen])
    const overlayOptions = useOverlayOptions({
      storageKey: "ov",
      initialFontStep: getKeyStage(ActivityData?.level_name), // 0=Small  1=Medium  2=Large
      initialFontFamily: getFontFamily(ActivityData?.level_name),
    })

    function getOverlayCardStyle() {
      return overlayOptions.cardStyle
    }

    function renderOverlayToggle() {
      return (
        <div className="mg-ov-anchor" ref={overlayAnchorRef}>
          <OverlayToggleButton
            onClick={() => {
              if (overlayAnchorRef.current) {
                const rect = overlayAnchorRef.current.getBoundingClientRect()
                setOverlayPanelPos({
                  top: rect.bottom - 60,
                  right: window.innerWidth - rect.right,
                  maxHeight: window.innerHeight - (rect.bottom - 60) - 16,
                })
              }
              setOverlayPanelOpen(o => !o)
            }}
          />
          <OverlayUI
            {...overlayOptions}
            panelOpen={overlayPanelOpen}
            setPanelOpen={setOverlayPanelOpen}
            onReset={overlayOptions.resetDefaults}
            panelPos={overlayPanelPos}
          />
        </div>
      )
    }

  // // ===== end Overlay Options =====

  const [customActiveTab, setcustomActiveTab] = useState(IsQuestionNo)

  function toggleCustom(tab) {
    // console.log(tab);
    if (customActiveTab !== tab) {
      setcustomActiveTab(tab)
    }
  }

  const [ResonTextData, setResonText] = useState("")
  const [modal_standard, setmodal_standard] = useState(false)

  const [isFlagReport, setFlagReport] = useState(false)

  const [selectedGroup, setselectedGroup] = useState(null)

  const [selectQuestion, setselectQuestion] = useState(null)

  function handleSelectGroup(selectedGroup) {
    setselectedGroup(selectedGroup)
  }

  const optionGroup = [
    // {
    // label: "Select Subject",
    // options: [
    { label: "Spelling error / Typo", value: "Spelling error / Typo" },
    { label: "The solution is wrong", value: "The solution is wrong" },
    {
      label: "The question is not relevant to the topic",
      value: "The question is not relevant to the topic",
    },
    {
      label: "The question cannot be solved",
      value: "The question cannot be solved",
    },
    {
      label: "The question is incomplete",
      value: "The question is incomplete",
    },
    { label: "Others", value: "Others" },
    // ],
    // },
  ]

  function textareachange(event) {
    const text = event.target.value
    // if (count > 0) {
    setResonText(text)
    // }
    //settextcount(event.target.value.length)
  }

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      reson: "",
      reson_text: "",
    },
    validationSchema: Yup.object({
      reson: Yup.mixed().required("Select a reason is required."),
      reson_text: Yup.string()
        .min(2, "Minimum 2 characters is required.")
        .max(250, "Maximum 250 characters is required.")
        .required("Reason is required.")
        .test(
          "not-empty-spaces",
          "Reason cannot be empty or just spaces.",
          value => value && value.trim().length > 0
        ),
    }),
    onSubmit: async values => {
      // console.log(values);

      if (authUser && authUser != "" && authUser != null) {
        setFlagReport(true)
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
        axios
          .post(BASE_URL + "studentSession/flagReport", {
            fk_lesson_activity_key: selectQuestion.fk_lesson_activity_key,
            fk_lesson_activity_question_key:
              selectQuestion.pk_lesson_activity_question_key,
            fk_sub_id: selectQuestion.fk_sub_id,
            question_id: selectQuestion.fk_question_id,
            // reson_text: ResonTextData,
            // reson: selectedGroup
            ...values,
          })
          .then(responseFlag => {
            //console.log(responseSessionEnd.data);
            // Assuming the API response is an array of objects with 'id' and 'value' properties
            if (parseInt(responseFlag.data) === 1) {
              tog_standard()
              setFlagReport(false)
              toast.success(
                "Thank you! Our Curriculum team will review and add 5 coins if the issue reported is correct.",
                {
                  autoClose: 3000, // 3 seconds in this example
                }
              )
            } else if (parseInt(responseFlag.data) === 2) {
              tog_standard()
              setFlagReport(false)
              toast.error("Already submitted a report on this question", {
                autoClose: 3000, // 3 seconds in this example
              })
            } else {
              tog_standard()
              setFlagReport(false)
              toast.error("Failure! Unable to insert data. Try again later", {
                autoClose: 3000, // 3 seconds in this example
              })
            }
          })
          .catch(error => {
            //console.log(error)
            tog_standard()
            setFlagReport(false)
            if (
              (error?.response?.status === 403 ||
                error?.response?.status === 401) &&
              error?.response?.data?.error === "jwt expired"
            ) {
              localStorage.clear()
              navigate("/login")
            }
          })
      } else {
        setFlagReport(false)
        navigate("/login")
      }

      //dispatch(loginUser(values, props.router.navigate));
    },
  })
  const tog_standard = data => {
    //console.log(data);
    setmodal_standard(!modal_standard)
    validation.resetForm()
    setselectedGroup(null)
    setResonText("")
    setselectQuestion(data ? data : null)
  }

  // function submitFlagReport(){
  //   if (authUser && authUser != "" && authUser != null) {

  //     setFlagReport(true);
  //       axios.defaults.headers.common['Authorization'] = `Bearer ${authUser}`
  //       axios.post(BASE_URL+'studentSession/flagReport', {
  //         fk_lesson_activity_key: selectQuestion.fk_lesson_activity_key,
  //         fk_lesson_activity_question_key : selectQuestion.pk_lesson_activity_question_key,
  //         fk_sub_id: selectQuestion.fk_sub_id,
  //         question_id: selectQuestion.fk_question_id,
  //         reson_text: ResonTextData,
  //         reson: selectedGroup
  //       }).then(responseFlag => {
  //         //console.log(responseSessionEnd.data);
  //         // Assuming the API response is an array of objects with 'id' and 'value' properties
  //         if (parseInt(responseFlag.data) === 1) {
  //           tog_standard();
  //           setFlagReport(false);
  //           toast.success("Thank you! Our Curriculum team will review and add 5 coins if the issue reported is correct.", {
  //             autoClose: 3000, // 3 seconds in this example
  //           });
  //         } else {
  //           tog_standard();
  //           setFlagReport(false);
  //           toast.error("Failure! Unable to insert data. Try again later", {
  //             autoClose: 3000, // 3 seconds in this example
  //           });
  //         }

  //       })
  //         .catch(error => {
  //           //console.log(error)
  //           tog_standard();
  //           setFlagReport(false);
  //           if ((error?.response?.status === 403 || error?.response?.status === 401) && error?.response?.data?.error === 'jwt expired') {
  //             localStorage.clear();
  //             navigate("/login");
  //           }
  //         });

  //   }
  //   else {
  //     setFlagReport(false);
  //     navigate("/login");
  //   }

  // }

  //console.log(ActivityData);

  // // Randomize the array once and save the fixed order
  // const options = ['123456', 'answer', 'option', 'this', 'randomize', 'option'];

  // // Shuffle the array only once
  // const fixedShuffledOptions = (function() {
  //     let array = [...options];
  //     for (let i = array.length - 1; i > 0; i--) {
  //         const j = Math.floor(Math.random() * (i + 1));
  //         [array[i], array[j]] = [array[j], array[i]];
  //     }
  //     return array;
  // })();

  // console.log(fixedShuffledOptions);

  //const options = ['123456', 'answer', 'option', 'this', 'randomize', 'option'];

  function rearrangeEvenOddSecond(array) {
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    return rearranged // Return the final rearranged array
  }

  function rearrangeEvenOdd(array) {
    array.sort((a, b) => {
      const textA = a.english_answer_text || a.answer_text || ""
      const textB = b.english_answer_text || b.answer_text || ""
      return textA.localeCompare(textB)
    })
    const even = [] // To store even-indexed elements
    const odd = [] // To store odd-indexed elements

    array.forEach((element, index) => {
      if (index % 2 === 0) {
        even.push(element)
      } else {
        odd.push(element)
      }
    })

    // Combine odd and even arrays
    const rearranged = [...odd, ...even]

    // Check if further rearrangement is needed
    if (rearranged.length > 1) {
      return rearrangeEvenOddSecond(rearranged) // Call recursively for further rearrangement
    }

    return rearranged // Return the final rearranged array
  }

  // Shuffle the array only once
  // const shuffleArray = (array) => {
  //   for (let i = array.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [array[i], array[j]] = [array[j], array[i]]; // Swap elements
  //   }
  //   return array;
  // }

  //Maths Answer guid start
  //const [popoverOpen, setPopoverOpen] = useState(false);
  const [openAccordion, setOpenAccordion] = useState("1")

  // const togglePopover = () => setPopoverOpen(!popoverOpen);
  const toggleAccordion = id => {
    setOpenAccordion(openAccordion === id ? "" : id)
  }

  // const [popoverOpen, setPopoverOpen] = useState({});

  // // Toggle function for individual popovers
  // const togglePopover = (id) => {
  //   setPopoverOpen((prevState) => ({
  //     ...prevState,
  //     [id]: !prevState[id], // Toggle the specific popover
  //   }));
  // };
  //Maths Answer guid end

  // State to track the currently open popover ID
  const [activePopoverId, setActivePopoverId] = useState(null)

  // Function to toggle the popover visibility
  const togglePopover = id => {
    // Toggle the popover: if it's open, close it, otherwise open it
    if (activePopoverId === id) {
      setActivePopoverId(null) // Close the popover if it's already open
    } else {
      setActivePopoverId(id) // Open the clicked popover and close others
    }
  }

  //passcode functionality start
  // console.log(otherData);
  const authTutorUser =
    JSON.parse(localStorage.getItem("authTutorUser")) || null
  const [modal_passcode, setmodal_passcod] = useState(false)
  const [isPassCode, setisPassCode] = useState(false)
  const [actvityData, setActvityData] = useState(null)
  const [actvityPartData, setActvityPartData] = useState(null)
  const [selectedOption, setSelectedOption] = useState(null)
  const [selectedStudentAnswer, setSelectedStudentAnswer] = useState(null)
  const [selectedAttemptId, setSelectedAttemptId] = useState(null)
  const [feedback, setFeedback] = useState("")
  const [error, setError] = useState(false) // For validation
  const [anserror, setansError] = useState(false) // For validation
  const [isOverSubmit, setisOverSubmit] = useState(false)
  const tog_passcode = (data = null, part = null) => {
    //console.log(data);
    setActivePopoverId(null)
    localStorage.removeItem("authTutorUser")
    setError(false)
    //console.log(part)
    setSelectedOption(null)
    setFeedback("")
    setmodal_passcod(!modal_passcode)
    setActvityData(data)
    setActvityPartData(part)
  }
  //console.log(actvityData)

  // Validation schema
  const validationSchemaPass = Yup.object({
    passcode: Yup.string()
      .matches(/^\d{6}$/, "Passcode must be exactly 6 digits")
      .required("Passcode is required"),
  })

  // Formik setup
  const validationPass = useFormik({
    initialValues: {
      passcode: "",
    },
    validationSchema: validationSchemaPass,
    onSubmit: values => {
      // console.log('Form values:', values);
      // console.log('Form submitted:', values);
      setisPassCode(true)

      axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`
      axios
        .post(BASE_URL + "tutorlogin/tutorAuthPasscode", {
          ...values,
          fk_tut_key: ActivityData?.fk_tut_key || null,
        })
        .then(responseData => {
          //console.log(responseSessionEnd.data);
          // Assuming the API response is an array of objects with 'id' and 'value' properties
          if (responseData.data.length > 0) {
            if (
              responseData.data[0]["token"] &&
              responseData.data[0]["token"] !== ""
            ) {
              localStorage.setItem(
                "authTutorUser",
                JSON.stringify(responseData.data[0]["token"])
              )

              

              if (
                actvityPartData.english_question_part_id &&
                actvityPartData.english_question_part_id != ""
              ) {
                setActivePopoverId(actvityPartData.english_question_part_id)
              } else if (
                actvityPartData.part_id &&
                actvityPartData.part_id != ""
              ) {
                setActivePopoverId(actvityPartData.part_id)
              } else {
                setActivePopoverId(null)
              }

              validationPass.setFieldValue("passcode", "")
              setmodal_passcod(false)

              setisPassCode(false)
            } else {
              toast.error("The passcode is wrong.", {
                autoClose: 3000, // 3 seconds in this example
              })
              setisPassCode(false)
            }
          } else {
            toast.error("The passcode is wrong.", {
              autoClose: 3000, // 3 seconds in this example
            })
            setisPassCode(false)
          }
        })
        .catch(error => {
          console.log(error)
          setisPassCode(false)
        })
      // Handle your form submission logic here
    },
  })
  const handleSubmit = () => {
    try {
      if (!selectedOption) {
        setError(true) // Show error if no option is selected
        return
      }
      if (selectedOption == 1 && !selectedAttemptId) {
        setansError(true)
        return
      }

      setError(false) // Clear error
      setansError(false) // Clear error
      setisOverSubmit(true)

      if (authUser && authUser != "" && authUser != null) {
        axios.defaults.headers.common["Authorization"] = `Bearer ${authUser}`

        const response = axios
          .post(BASE_URL + "studentSession/OverRideActivities", {
            fk_lesson_activity_key: actvityData.fk_lesson_activity_key,
            pk_lesson_activity_question_key:
              actvityData.pk_lesson_activity_question_key,
            fk_student_key: actvityData.fk_student_key,
            fk_question_id: actvityData.fk_question_id,
            fk_sub_id: actvityData.fk_sub_id,
            part_id:
              actvityData.fk_sub_id == 1
                ? actvityPartData.english_question_part_id
                : actvityPartData.part_id,
            is_rewarded: selectedOption == 1 ? 1 : 0,
            rewards: selectedOption == 1 ? 5 : 0,
            pk_attempt_id: selectedAttemptId ? selectedAttemptId : "",
            studanswer_id: selectedStudentAnswer ? selectedStudentAnswer : "",
            flag_text: feedback,
            fk_tut_key: actvityData.fk_tut_key,
            fk_sest_key: ActivityData.fk_sest_key,
            fk_lesson_key: ActivityData.fk_lesson_key,
            topic_id: actvityData.topic_id,
          })
          .then(responseReport => {
            setisOverSubmit(false)

            if (responseReport.data == 1) {
              toast.success("Your report added successfully.", {
                autoClose: 3000,
              })
              setActivePopoverId(null)
              localStorage.removeItem("authTutorUser")
              setError(false)
              window.location.reload()
            }
          })
          .catch(error => {
            setisOverSubmit(false)
            console.error("Error fetching options from API: ", error)
          })
      }
    } catch (error) {
      console.error("Error fetching data:", error)
      toast.error("Failure! Unable to added your report. Try again later", {
        autoClose: 3000, // 3 seconds in this example
      })

      setisOverSubmit(false)
    } finally {
      setisOverSubmit(false)
    }
  }
  //passcode functionality end

  function renderSpeakerToggle(id, content) {
    const htmlContent = Array.isArray(content)
      ? content.filter(Boolean).join(" ")
      : content
    //   const htmlContent = Array.isArray(content)
    // ? content.join(" ")
    // : content;

    const isYear = isYearOneToThree(ActivityData?.level_name);

    return htmlContent?.trim() && isYear ? (
      <div>
        <SpeakerButton
          id={`q-text-${id}`}
          html={htmlContent}
          speak={speak}
          stop={stop}
          activeId={activeId}
        />
      </div>
    ) : null
  }

  return (
    <React.Fragment>
      <MathJax inline dynamic>
        <Loader
          show={loader}
          type="body"
          // stack="vertical"
          // message="Loading Data"
        />
        <ToastContainer autoClose={3000} />

        <Modal isOpen={modal_passcode} toggle={tog_passcode}>
          <form
            className="mt-0"
            onSubmit={e => {
              e.preventDefault()
              validationPass.handleSubmit()
              return false
            }}
          >
            <ModalBody>
              <div className="flex-grow-1 cs-rsm mb-3">
                <Label for="passcode_text">Enter your 6 digit passcode:</Label>
                <Input
                  type="password"
                  name="passcode"
                  id="passcode"
                  autoComplete="off"
                  onChange={validationPass.handleChange}
                  onBlur={validationPass.handleBlur}
                  value={validationPass.values.passcode}
                  invalid={
                    validationPass.touched.passcode &&
                    !!validationPass.errors.passcode
                  }
                />
                {validationPass.touched.passcode &&
                validationPass.errors.passcode ? (
                  <div className="invalid-feedback-all">
                    {validationPass.errors.passcode}
                  </div>
                ) : null}
              </div>
              <div className="d-flex justify-content-center gap-3">
                <Button
                  type="button"
                  className="btn-cst-danger-md"
                  onClick={() => {
                    setmodal_passcod(false)
                    validationPass.setFieldValue("passcode", "")
                  }}
                >
                  Cancel
                </Button>
                <Button
                  type="submit"
                  className="btn-cst-success-md"
                  disabled={isPassCode}
                >
                  Submit
                </Button>
              </div>
            </ModalBody>
          </form>
        </Modal>

        <Modal isOpen={modal_standard} toggle={tog_standard}>
          <Form
            className="mt-4"
            onSubmit={e => {
              e.preventDefault()
              validation.handleSubmit()
              return false
            }}
            action="#"
          >
            <ModalHeader toggle={tog_standard}>Flag this Question</ModalHeader>
            <ModalBody>
              <div className="flex-grow-1 mb-3 cs-rsm">
                <Label>Select a Reason</Label>
                <Select
                  name="reson"
                  id="reson"
                  className="cs-style bg-mutant"
                  value={optionGroup.find(
                    option =>
                      option.value &&
                      validation.values.reson &&
                      option.value.toString() ==
                        validation.values.reson.toString()
                  )}
                  placeholder="Select"
                  onChange={selectedOption => {
                    const event = {
                      target: {
                        name: "reson",
                        value: selectedOption["value"],
                      },
                    }
                    validation.handleChange(event)
                  }}
                  onBlur={event => {
                    validation.handleBlur(event)
                  }}
                  // invalid={
                  //   validation.touched.reson &&
                  //   validation.errors.reson
                  //     ? true
                  //     : false
                  // }
                  options={optionGroup}
                  classNamePrefix="select2-selection"
                />
                {validation.touched.reson && validation.errors.reson ? (
                  <div className="invalid-feedback-all">
                    {validation.errors.reson}
                  </div>
                ) : null}
              </div>
              <div className="flex-grow-1 cs-rsm">
                <Label>Reason:</Label>
                <Input
                  style={{ height: "200px" }}
                  type="textarea"
                  name="reson_text"
                  id="reson_text"
                  // onChange={e=> {
                  // textareachange(e)
                  // }}
                  onChange={validation.handleChange}
                  onBlur={validation.handleBlur}
                  value={validation.values.reson_text || ""}
                  // invalid={
                  //   validation.touched.reson_text &&
                  //   validation.errors.reson_text
                  //     ? true
                  //     : false
                  // }
                  maxLength="225"
                  rows="3"
                  placeholder="Write your reason here..."
                />
                {validation.touched.reson_text &&
                validation.errors.reson_text ? (
                  <div className="invalid-feedback-all">
                    {validation.errors.reson_text}
                  </div>
                ) : null}
              </div>
            </ModalBody>
            <ModalFooter className="justify-content-center">
              <Button
                type="submit"
                className="btn btn-danger cs-btn-danger"
                disabled={isFlagReport}
              >
                Submit
              </Button>
            </ModalFooter>
          </Form>
        </Modal>

        <div className="page-wrapper">
          <div className="cs-pg-header bg-dark-blue py-4">
            <Container className="custom-wt" style={overlayOptions.headingStyle}>
              <div className="d-flex align-items-center">
                <div
                  className="mt-0 border-right me-4"
                  style={{ width: "20%" }}
                >
                  <div
                    className="text-white text-uppercase"
                    to={"#"}
                    onClick={() => history.back()}
                  >
                    {" "}
                    <span>
                      <i className=" fas fa-chevron-left me-1"></i>
                    </span>{" "}
                    Back
                  </div>
                </div>
                <div className="d-flex align-items-center justify-content-between flex-grow-1">
                  <div className="mb-0 text-white w-60 fw-regular fw-500">
                    {ActivityData &&
                    ActivityData?.activity_type === 0 &&
                    ActivityData.activity_node &&
                    ActivityData.activity_node[0]?.node_name
                      ? ActivityData.activity_node[0].node_name
                      : null}
                    {ActivityData &&
                    ActivityData?.activity_type === 8 &&
                    ActivityData.activity_node &&
                    ActivityData.activity_node[0]?.name
                      ? ActivityData.activity_node[0].name
                      : null}
                  </div>
                  <p className="mb-0 text-uppercase luminous-wht" style={{
                  transform: "scale(0.9)",
                  transformOrigin: "top center",
                }}>
                    {" "}
                    <span className="text-yellow me-1">
                      {ActivityData && ActivityData.subject_name
                        ? ActivityData.subject_name
                        : null}
                    </span>{" "}
                    {ActivityData?.activity_type === 8
                      ? "Summative"
                      : "Online Activities"}{" "}
                  </p>
                  <div className="coins-badge">
                    <img width={24} src={awicon} alt="" />
                    <div className="coins-badge__info">
                      <span className="coins-badge__count">
                        {ActivityData && ActivityData.coins_earned
                          ? ActivityData.coins_earned
                          : 0}
                        /
                        {ActivityData &&
                        ActivityData.LessonActivitiesQuestions &&
                        ActivityData.LessonActivitiesQuestions.length > 0
                          ? CountTotalCoins(ActivityData.LessonActivitiesQuestions)
                          : 0}
                      </span>
                      <span className="coins-badge__label">coins</span>
                    </div>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <Container className="custom-wt">
            <div className="assessement-section summary-width-hold mt-4">
              <Nav tabs className="nav-tabs-custom nav-tabs-new mb-3">
                {ActivityData &&
                ActivityData.LessonActivitiesQuestions &&
                ActivityData.LessonActivitiesQuestions.length > 0
                  ? ActivityData.LessonActivitiesQuestions.map((activity, index) => {
                      if (
                        activity.english_question &&
                        activity.english_question.length > 0 &&
                        parseInt(activity.fk_sub_id) === 1
                      ) {
                        return activity.english_question.map((question, index1) => {
                          if (
                            parseInt(question.english_question_category_id) === 1 ||
                            parseInt(question.english_question_category_id) === 8 ||
                            parseInt(question.english_question_category_id) === 2 ||
                            parseInt(question.english_question_category_id) === 12 ||
                            parseInt(question.english_question_category_id) === 13 ||
                            parseInt(question.english_question_category_id) === 10
                          ) {
                            let filteredManualMark = question.english_question_parts.filter(
                              manualMark =>
                                parseInt(manualMark.english_question_part_automark) === 0 &&
                                manualMark.english_question_answers &&
                                manualMark.english_question_answers.length > 0 &&
                                manualMark.english_question_answers[0].english_answer_text &&
                                manualMark.english_question_answers[0].english_answer_text !== ""
                            )

                            // ── existing logic: compute question_status ──────────────────
                            let question_status = 1
                            if (
                              question.english_question_parts &&
                              question.english_question_parts.length > 0
                            ) {
                              question.english_question_parts.forEach(
                                (activityQuestionPart) => {
                                  let partManualMark = parseInt(
                                    activityQuestionPart.english_question_part_automark
                                  )
                                  let total_mark = 0
                                  if (
                                    activityQuestionPart.StudentAnsAttempts &&
                                    activityQuestionPart.StudentAnsAttempts.length > 0
                                  ) {
                                    activityQuestionPart.StudentAnsAttempts.forEach(
                                      (stuAnswer) => {
                                        if (stuAnswer.points_obtained != null) {
                                          total_mark += parseInt(stuAnswer.points_obtained)
                                        }
                                      }
                                    )
                                    if (
                                      ((activityQuestionPart?.markedReport > 0 &&
                                        activityQuestionPart.StudentAnsAttempts.length >= 1) ||
                                        activityQuestionPart.StudentAnsAttempts.length >= 2) &&
                                      total_mark === 0
                                    ) {
                                      question_status = 3
                                    } else if (
                                      activityQuestionPart.StudentAnsAttempts.length >= 1 &&
                                      total_mark >= 2
                                    ) {
                                      question_status = 4
                                    } else if (
                                      activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                                      total_mark > 0
                                    ) {
                                      question_status = 5
                                    } else if (
                                      activityQuestionPart.StudentAnsAttempts.length === 1 &&
                                      total_mark >= 0 &&
                                      partManualMark <= 0
                                    ) {
                                      question_status = 2
                                    } else {
                                      question_status = 2
                                    }
                                  } else {
                                    question_status = 2
                                  }
                                }
                              )
                            }
                            // ── end status logic ─────────────────────────────────────────

                            const isActiveTab = parseInt(customActiveTab) === index + 1
                            const label = filteredManualMark.length > 0 ? "M" : index + 1

                            return (
                              <NavItem key={index}>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  onClick={() => toggleCustom(index + 1)}
                                  className={
                                    (isActiveTab ? "active" : "") +
                                    resolveNavClass(question_status, isActiveTab)
                                  }
                                >
                                  {renderNavContent(question_status, label)
                                  }
                                </NavLink>
                              </NavItem>
                            )
                          }
                        })
                      } else if (
                        activity.question &&
                        activity.question.length > 0 &&
                        parseInt(activity.fk_sub_id) === 2
                      ) {
                        return activity.question.map((question, index1) => {
                          if (question.question_id != null) {
                            let filteredManualMark = []

                            // ── existing logic: compute question_status ──────────────────
                            let question_status = 1
                            if (
                              question.question_parts &&
                              question.question_parts.length > 0
                            ) {
                              question.question_parts.forEach((activityQuestionPart) => {
                                let total_mark = 0
                                if (
                                  activityQuestionPart.StudentAnsAttempts &&
                                  activityQuestionPart.StudentAnsAttempts.length > 0
                                ) {
                                  activityQuestionPart.StudentAnsAttempts.forEach(
                                    (stuAnswer) => {
                                      if (stuAnswer.points_obtained != null) {
                                        total_mark += parseInt(stuAnswer.points_obtained)
                                      }
                                    }
                                  )
                                  if (
                                    ((activityQuestionPart?.markedReport > 0 &&
                                      activityQuestionPart.StudentAnsAttempts.length >= 1) ||
                                      activityQuestionPart.StudentAnsAttempts.length >= 2) &&
                                    total_mark === 0
                                  ) {
                                    question_status = 3
                                  } else if (
                                    activityQuestionPart.StudentAnsAttempts.length >= 1 &&
                                    total_mark >= 2
                                  ) {
                                    question_status = 4
                                  } else if (
                                    activityQuestionPart.StudentAnsAttempts.length >= 2 &&
                                    total_mark > 0
                                  ) {
                                    question_status = 5
                                  } else {
                                    question_status = 2
                                  }
                                } else {
                                  question_status = 2
                                }
                              })
                            }
                            // ── end status logic ─────────────────────────────────────────

                            const isActiveTab = parseInt(customActiveTab) === index + 1
                            const label = filteredManualMark.length > 0 ? "M" : index + 1

                            return (
                              <NavItem key={index}>
                                <NavLink
                                  style={{ cursor: "pointer" }}
                                  onClick={() => toggleCustom(index + 1)}
                                  className={
                                    (isActiveTab ? "active" : "") +
                                    resolveNavClass(question_status, isActiveTab)
                                  }
                                >
                                  {renderNavContent(question_status, label)}
                                </NavLink>
                              </NavItem>
                            )
                          }
                        })
                      } else {
                        // else — no change
                      }
                    })
                  : null}
              </Nav>

              <p className="font-size-16 fw-semibold mb-2 mt-2">
                {ActivityData?.marked_for_homework >= 0 && (
                  <>
                    {ActivityData?.homework_tutor_message &&
                    ActivityData.marked_for_homework == 1 ? (
                      <>
                        <b>Tutor message:</b>{" "}
                        {ActivityData.homework_tutor_message}
                      </>
                    ) : ActivityData?.lesson_tutor_message ? (
                      <>
                        <b>Tutor message:</b>{" "}
                        {ActivityData.lesson_tutor_message}
                      </>
                    ) : null}
                  </>
                )}
              </p>
              <p className="font-size-16 fw-semibold mb-2">
                {ActivityData?.tutor_comments && (
                  <>
                    <b>Tutor comments:</b> {ActivityData.tutor_comments}
                  </>
                )}
              </p>

              <TabContent activeTab={customActiveTab} className="text-muted">
                {ActivityData &&
                ActivityData.LessonActivitiesQuestions &&
                ActivityData.LessonActivitiesQuestions.length > 0
                  ? ActivityData.LessonActivitiesQuestions.map(
                      (ActivityData1, activeindex) => {
                        if (
                          ActivityData1.english_question &&
                          ActivityData1.english_question.length > 0 &&
                          parseInt(ActivityData1.fk_sub_id) === 1
                        ) {
                          return ActivityData1.english_question.map(
                            (InnerActivityData, index) => {
                              if (index === 0) {
                                if (
                                  InnerActivityData &&
                                  InnerActivityData.english_question_category_id &&
                                  parseInt(
                                    InnerActivityData.english_question_category_id
                                  ) === 1
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div
                                        style={getOverlayCardStyle()}
                                        className={`hw-list mt-4 pb-3 ${
                                          localStorage.getItem("is_fontsize") ==
                                          1
                                            ? "stu-custom-font-size"
                                            : ""
                                        }`}
                                      >
                                        <ul className="list-unstyled mb-0 question_container">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end nv-sticky-header">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                      {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.level_name ? 
                                      InnerActivityData.english_question_has_sub_topic.level_name +' /' : null}
                                      
                                      {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.strand_name ? 
                                      InnerActivityData.english_question_has_sub_topic.strand_name +' /' : null}
              
                                      {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.topic_name ? 
                                      InnerActivityData.english_question_has_sub_topic.topic_name +' /' : null}
              
                                      {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.sub_topic_name ? 
                                      InnerActivityData.english_question_has_sub_topic.sub_topic_name : null}
                                  
                                    </p> */}
                                              <div className="mb-0 d-flex align-items-center gap-2">
                                                <p className="mb-0">
                                                  #
                                                  {InnerActivityData.english_question_id
                                                    ? InnerActivityData.english_question_id
                                                    : null}
                                                </p>
                                                <span
                                                  onClick={() =>
                                                    tog_standard(ActivityData1)
                                                  }
                                                >
                                                  <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                                </span>
                                              </div>
                                              {parseInt(customActiveTab) === activeindex + 1 && renderOverlayToggle()}
                                            </div>
                                           <div class="d-flex align-items-start gap-3 mb-3">
                                              {renderSpeakerToggle(index, [
                                                InnerActivityData.english_question_text,
                                              ])}
                                              <div
  style={{ flex: 1 }}
  dangerouslySetInnerHTML={{
    __html:
      InnerActivityData.english_question_text
                                                      ? InnerActivityData.english_question_text
                                                          .replace(
                                                            /\[(\d+)Answer char=\d+\]/g,
                                                            ""
                                                          )
                                                          .replace(
                                                            /\[Answer char=\d+\]/g,
                                                            ""
                                                          )
                                                      : null,
                                                }}
                                              ></div>
                                              {InnerActivityData.english_question_parts &&
                                                InnerActivityData.english_question_parts.map(
                                                  (quspart, index) => (
                                                    <div key={index}>
                                                      {((quspart
                                                        .StudentAnsAttempts
                                                        .length > 0 &&
                                                        quspart.english_question_part_automark ==
                                                          1) ||
                                                        (quspart.english_question_part_automark !=
                                                          1 &&
                                                          ActivityData1.marked_for_manual_marking ==
                                                            1)) &&
                                                        (quspart.markedReport &&
                                                        quspart.markedReport >
                                                          0 ? (
                                                          <div>
                                                            {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                            <span className="badge bg-warning font-size-12 mt-auto mb-2">
                                                              Override
                                                            </span>
                                                          </div>
                                                        ) : (
                                                          <div>
                                                            <i
                                                              id={`Popover_mark_override_${quspart.english_question_part_id}`}
                                                              className="mdi mdi-clipboard-check-outline font-size-18"
                                                              onClick={() =>
                                                                tog_passcode(
                                                                  ActivityData1,
                                                                  quspart
                                                                )
                                                              }
                                                            ></i>
                                                            {/* Popover */}
                                                            {authTutorUser && (
                                                              <UncontrolledPopover
                                                                //placement="bottom"
                                                                trigger="legacy"
                                                                target={`Popover_mark_override_${quspart.english_question_part_id}`} // Matches button ID
                                                                isOpen={
                                                                  activePopoverId ===
                                                                  quspart.english_question_part_id
                                                                } // Only open the popover if its ID matches the active one
                                                                toggle={() =>
                                                                  togglePopover(
                                                                    quspart.english_question_part_id
                                                                  )
                                                                } // Toggle popover visibility
                                                                onClosed={() =>
                                                                  console.log(
                                                                    "close"
                                                                  )
                                                                } // Custom function when popover is closed
                                                              >
                                                                <PopoverBody
                                                                  className="shadow rounded bg-white p-3"
                                                                  style={{
                                                                    width:
                                                                      "300px",
                                                                  }}
                                                                >
                                                                  <p>
                                                                    <strong>
                                                                      Is the
                                                                      student
                                                                      answer
                                                                      correct?
                                                                    </strong>
                                                                  </p>
                                                                  {/* Yes / No Checkboxes */}
                                                                  <div className="d-flex justify-content-around my-2">
                                                                    <label
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        type="radio"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        name={`correct_${quspart.english_question_part_id}`}
                                                                        value="1"
                                                                        checked={
                                                                          selectedOption ==
                                                                          "1"
                                                                        }
                                                                        onChange={() => {
                                                                          if (
                                                                            quspart.StudentAnsAttempts.every(
                                                                              attempt =>
                                                                                attempt.attempt_status ===
                                                                                1
                                                                            )
                                                                          ) {
                                                                            toast.error(
                                                                              "Already status correct",
                                                                              {
                                                                                autoClose: 3000, // 3 seconds in this example
                                                                              }
                                                                            )
                                                                          } else {
                                                                            setSelectedOption(
                                                                              "1"
                                                                            )
                                                                            setError(
                                                                              false
                                                                            )
                                                                          }
                                                                        }}
                                                                      />{" "}
                                                                      Yes
                                                                    </label>
                                                                    <label
                                                                      style={{
                                                                        cursor:
                                                                          "pointer",
                                                                      }}
                                                                    >
                                                                      <input
                                                                        type="radio"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                        name={`correct_${quspart.english_question_part_id}`}
                                                                        value="0"
                                                                        checked={
                                                                          selectedOption ==
                                                                          "0"
                                                                        }
                                                                        onChange={() => {
                                                                          if (
                                                                            quspart.StudentAnsAttempts.every(
                                                                              attempt =>
                                                                                attempt.attempt_status ===
                                                                                0
                                                                            )
                                                                          ) {
                                                                            toast.error(
                                                                              "Already status incorrect",
                                                                              {
                                                                                autoClose: 3000, // 3 seconds in this example
                                                                              }
                                                                            )
                                                                          } else {
                                                                            setSelectedOption(
                                                                              "0"
                                                                            )
                                                                            setError(
                                                                              false
                                                                            )
                                                                          }
                                                                        }}
                                                                        // disabled={}
                                                                      />{" "}
                                                                      No
                                                                    </label>
                                                                  </div>
                                                                  {/* Error message if checkbox is not selected */}
                                                                  {error && (
                                                                    <p className="text-danger text-center">
                                                                      Please
                                                                      select Yes
                                                                      or No
                                                                    </p>
                                                                  )}
                                                                  {(selectedOption ==
                                                                    "1" ||
                                                                    selectedOption ==
                                                                      "0") && (
                                                                    <div className="student-answers mt-3">
                                                                      <h5>
                                                                        Student
                                                                        Answers:
                                                                      </h5>
                                                                      <ul className="list-group">
                                                                        {quspart
                                                                          .StudentAnsAttempts
                                                                          .length >
                                                                        0 ? (
                                                                          quspart.StudentAnsAttempts.filter(
                                                                            stuAns => {
                                                                              const attemptStatus =
                                                                                parseInt(
                                                                                  stuAns.attempt_status
                                                                                )
                                                                              return selectedOption ===
                                                                                "1"
                                                                                ? attemptStatus ===
                                                                                    0
                                                                                : attemptStatus ===
                                                                                    1
                                                                            }
                                                                          ).map(
                                                                            (
                                                                              stuAns,
                                                                              index
                                                                            ) => {
                                                                              const studentAnswer =
                                                                                JSON.parse(
                                                                                  stuAns.student_answer
                                                                                )
                                                                              const flatStuAnswers =
                                                                                [].concat(
                                                                                  ...studentAnswer
                                                                                )

                                                                              const filterStuAns =
                                                                                flatStuAnswers.filter(
                                                                                  stuAns =>
                                                                                    quspart?.english_question_answers?.some(
                                                                                      answer =>
                                                                                        parseInt(
                                                                                          stuAns.part_id
                                                                                        ) ===
                                                                                          parseInt(
                                                                                            answer.english_answer_part_id
                                                                                          ) &&
                                                                                        parseInt(
                                                                                          stuAns.answer_id
                                                                                        ) ===
                                                                                          parseInt(
                                                                                            answer.english_answer_id
                                                                                          )
                                                                                    )
                                                                                ) ||
                                                                                []

                                                                              return filterStuAns.length >
                                                                                0
                                                                                ? filterStuAns.map(
                                                                                    (
                                                                                      filteredAns,
                                                                                      filteredIndex
                                                                                    ) => {
                                                                                      return (
                                                                                        <>
                                                                                          <li
                                                                                            className="list-group-item"
                                                                                            key={`${index}_${filteredIndex}`}
                                                                                          >
                                                                                            <div
                                                                                              className="d-flex align-items-center gap-1"
                                                                                              onClick={() => {
                                                                                                setSelectedStudentAnswer(
                                                                                                  filteredAns.answer_id
                                                                                                )
                                                                                                setSelectedAttemptId(
                                                                                                  stuAns.pk_attempt_id
                                                                                                )
                                                                                                setansError(
                                                                                                  false
                                                                                                )
                                                                                              }}
                                                                                              style={{
                                                                                                cursor:
                                                                                                  "pointer",
                                                                                              }}
                                                                                            >
                                                                                              {/* Allow user to select the answer */}
                                                                                              <input
                                                                                                type="radio"
                                                                                                name={`selected_answer_${index}`}
                                                                                                value={
                                                                                                  filteredAns.answer_id
                                                                                                }
                                                                                                checked={
                                                                                                  selectedStudentAnswer ===
                                                                                                  filteredAns.answer_id
                                                                                                }
                                                                                                onChange={() => {
                                                                                                  setSelectedStudentAnswer(
                                                                                                    filteredAns.answer_id
                                                                                                  )
                                                                                                  setSelectedAttemptId(
                                                                                                    stuAns.pk_attempt_id
                                                                                                  )
                                                                                                  setansError(
                                                                                                    false
                                                                                                  )
                                                                                                }}
                                                                                              />
                                                                                              <div
                                                                                                dangerouslySetInnerHTML={{
                                                                                                  __html:
                                                                                                    filteredAns.text ||
                                                                                                    "No answer provided",
                                                                                                }}
                                                                                              ></div>
                                                                                            </div>
                                                                                          </li>
                                                                                        </>
                                                                                      )
                                                                                    }
                                                                                  )
                                                                                : null
                                                                            }
                                                                          )
                                                                        ) : (
                                                                          <li className="list-group-item">
                                                                            No
                                                                            student
                                                                            answers
                                                                            available
                                                                          </li>
                                                                        )}
                                                                      </ul>
                                                                      {anserror && (
                                                                        <p className="text-danger text-center">
                                                                          Please
                                                                          select
                                                                          the
                                                                          correct
                                                                          answer
                                                                        </p>
                                                                      )}
                                                                    </div>
                                                                  )}
                                                                  {/* Feedback Textarea */}
                                                                  <textarea
                                                                    className="form-control my-2"
                                                                    placeholder="Enter feedback..."
                                                                    value={
                                                                      feedback
                                                                    }
                                                                    onChange={e =>
                                                                      setFeedback(
                                                                        e.target
                                                                          .value
                                                                      )
                                                                    }
                                                                  ></textarea>

                                                                  {/* Buttons */}
                                                                  <div className="d-flex justify-content-between mt-3">
                                                                    <button
                                                                      className="btn btn-secondary btn-sm"
                                                                      onClick={() =>
                                                                        setActivePopoverId(
                                                                          null
                                                                        )
                                                                      }
                                                                    >
                                                                      Cancel
                                                                    </button>
                                                                    <button
                                                                      className="btn btn-primary btn-sm"
                                                                      onClick={
                                                                        handleSubmit
                                                                      }
                                                                    >
                                                                      Submit
                                                                    </button>
                                                                  </div>
                                                                </PopoverBody>
                                                              </UncontrolledPopover>
                                                            )}
                                                          </div>
                                                        ))}
                                                    </div>
                                                  )
                                                )}
                                            </div>

                                            <ul className="dg-selector choose-it-question  width-controll list-unstyled mb-0">
                                              {InnerActivityData.english_question_parts &&
                                                InnerActivityData.english_question_parts.map(
                                                  (quspart, index) => {
                                                    //const stuAnswersarray = quspart.StudentAnsAttempts.map(stuAns => stuAns.student_answer);

                                                    const stuAnswersarray =
                                                      quspart.StudentAnsAttempts.map(
                                                        stuAns => {
                                                          try {
                                                            return JSON.parse(
                                                              stuAns.student_answer
                                                            )
                                                          } catch (error) {
                                                            console.error(
                                                              "Error parsing JSON:",
                                                              error
                                                            )
                                                            return null // or handle the error in an appropriate way
                                                          }
                                                        }
                                                      ) || [] // Extracting session keys

                                                    // Assuming stuAnswersarray is a nested array
                                                    const flattenedStuAnswers =
                                                      [].concat(
                                                        ...stuAnswersarray
                                                      )
                                                    //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];

                                                    let serialNumber = 0
                                                    return (
                                                      quspart.english_question_answers &&
                                                      rearrangeEvenOdd(
                                                        quspart.english_question_answers
                                                      ).map(
                                                        (qusAns, index1) => {
                                                          const cleanText =
                                                            qusAns.english_answer_text
                                                              .replace(
                                                                /&nbsp;/g,
                                                                ""
                                                              )
                                                              .replace(/`/g, "")
                                                              .replace(
                                                                /<[^>]*>/g,
                                                                ""
                                                              )
                                                              .trim()

                                                          const hasImage =
                                                            /<img\s+[^>]*>/gi.test(
                                                              qusAns.english_answer_text
                                                            )

                                                          if (
                                                            !cleanText &&
                                                            !hasImage
                                                          ) {
                                                            return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                          }

                                                          serialNumber++

                                                          let filteredStuAns =
                                                            flattenedStuAnswers.filter(
                                                              stuAns =>
                                                                parseInt(
                                                                  stuAns.part_id
                                                                ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_part_id
                                                                  ) &&
                                                                parseInt(
                                                                  stuAns.answer_id
                                                                ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                            ) || []
                                                          let filteredStuAnsoverridedata =
                                                            quspart.StudentAnsAttempts.filter(
                                                              stuAns =>
                                                                parseInt(
                                                                  stuAns.attempt_status
                                                                ) === 1
                                                            ) || []
                                                          const stuAnswersoverridearray =
                                                            filteredStuAnsoverridedata.map(
                                                              stuAns => {
                                                                try {
                                                                  return JSON.parse(
                                                                    stuAns.student_answer
                                                                  )
                                                                } catch (error) {
                                                                  console.error(
                                                                    "Error parsing JSON:",
                                                                    error
                                                                  )
                                                                  return null // or handle the error in an appropriate way
                                                                }
                                                              }
                                                            ) || []
                                                          const flattenedoverrideStuAnswers =
                                                            [].concat(
                                                              ...stuAnswersoverridearray
                                                            )

                                                          let filteredStuAnsoverride =
                                                            flattenedoverrideStuAnswers.filter(
                                                              stuAns =>
                                                                parseInt(
                                                                  stuAns.part_id
                                                                ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_part_id
                                                                  ) &&
                                                                parseInt(
                                                                  stuAns.answer_id
                                                                ) ===
                                                                  parseInt(
                                                                    qusAns.english_answer_id
                                                                  )
                                                            ) || []

                                                          var status_color =
                                                            "selector-general cursor-pointer"
                                                          var border_color =
                                                            "border-start-secondary"
                                                          if (
                                                            filteredStuAns.length >
                                                            0
                                                          ) {
                                                            if (
                                                              parseInt(
                                                                qusAns.english_answer_is_correct
                                                              ) === 1 &&
                                                              !quspart?.markedReport >
                                                                0
                                                            ) {
                                                              status_color =
                                                                "selector-success"
                                                              border_color =
                                                                "border-start-success"
                                                            } else if (
                                                              filteredStuAnsoverride.length >
                                                                0 &&
                                                              quspart.markedReport >
                                                                0
                                                            ) {
                                                              status_color =
                                                                "selector-success"
                                                              border_color =
                                                                "border-start-success"
                                                            } else {
                                                              status_color =
                                                                "selector-wrong "
                                                              border_color =
                                                                "border-start-danger"
                                                            }
                                                          }

                                                          //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                          return (
                                                            <li
                                                              className={
                                                                status_color +
                                                                " choose e_choose"
                                                              }
                                                              key={index1}
                                                            >
                                                              <div
                                                                style={{
                                                                  position: "absolute",
                                                                  left: "-40px",
                                                                  top: "50%",
                                                                  transform: "translateY(-50%)",
                                                                }}
                                                                onClick={e => e.stopPropagation()}
                                                              >
                                                                {renderSpeakerToggle(
                                                                  "ans-" + qusAns.english_answer_id,
                                                                  [qusAns.english_answer_text]
                                                                )}
                                                              </div>
                                                              <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                                                <span className="dg-serial-badge">{serialNumber}</span>
                                                              </div>
                                                              <div
                                                                className={
                                                                  "p-2 dg-media " +
                                                                  {
                                                                    border_color,
                                                                  }
                                                                }
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    qusAns.english_answer_text
                                                                      ? qusAns.english_answer_text
                                                                      : null,
                                                                }}
                                                              ></div>
                                                            </li>
                                                          )
                                                        }
                                                      )
                                                    )
                                                  }
                                                )}
                                            </ul>
                                            <>
                                              {InnerActivityData.english_question_parts &&
                                                InnerActivityData.english_question_parts.map(
                                                  (quspart, index) => {
                                                    let filteredAns = []
                                                    if (
                                                      quspart.StudentQusSkip
                                                        ?.length === 0
                                                    ) {
                                                      filteredAns =
                                                        quspart.english_question_answers.filter(
                                                          CorrAns =>
                                                            parseInt(
                                                              CorrAns.english_answer_is_correct
                                                            ) === 1
                                                        )
                                                    }
                                                    return filteredAns.map(
                                                      (qusAns, index1) => {
                                                        return (
                                                          <>
                                                            {index1 === 0 ? (
                                                              <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                                Solution
                                                              </h4>
                                                            ) : null}
                                                            <div
                                                              className="e_feedBack"
                                                              style={{
                                                                border:
                                                                  "1px solid #1a1a1a",
                                                                borderRadius:
                                                                  "4px",
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            >
                                                              <div
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    qusAns.english_answer_text
                                                                      ? qusAns.english_answer_text
                                                                      : null,
                                                                }}
                                                              ></div>
                                                            </div>
                                                          </>
                                                        )
                                                      }
                                                    )
                                                  }
                                                )}
                                            </>
                                          </li>
                                        </ul>

                                        <div className={'action-btns d-flex gap-4 mt-2'+ (activeindex + 1 > 1 ? ' justify-content-between' : ' justify-content-end')}>
                                          {/* Render a "Prev" button if the active index is greater than 0 */}
                                          {activeindex + 1 > 1 ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(activeindex)
                                              }}
                                            >
                                              Prev
                                            </Button>
                                          ) : null}

                                          {/* Render a "Next" button if the active index is less than the total length of LessonActivitiesQuestions array */}
                                          {activeindex + 1 <
                                          ActivityData.LessonActivitiesQuestions
                                            .length ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(
                                                  activeindex + 1 + 1
                                                )
                                              }}
                                            >
                                              Next
                                            </Button>
                                          ) : null}
                                        </div>
                                      </div>
                                    </TabPane>
                                  )
                                } else if (
                                  InnerActivityData &&
                                  InnerActivityData.english_question_category_id &&
                                  (parseInt(
                                    InnerActivityData.english_question_category_id
                                  ) === 8 ||
                                    parseInt(
                                      InnerActivityData.english_question_category_id
                                    ) === 2 ||
                                    parseInt(
                                      InnerActivityData.english_question_category_id
                                    ) === 12)
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div
                                        style={getOverlayCardStyle()}
                                        className={`hw-list mt-4 pb-2 not_scroll ${
                                          localStorage.getItem("is_fontsize") ==
                                          1
                                            ? "stu-custom-font-size"
                                            : ""
                                        }`}
                                      >
                                        <ul className="list-unstyled mb-0 question_container">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end nv-sticky-header">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.level_name ? 
                                  InnerActivityData.english_question_has_sub_topic.level_name +' /' : null}
                                  
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.strand_name ? 
                                  InnerActivityData.english_question_has_sub_topic.strand_name +' /' : null}
          
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.topic_name ? 
                                  InnerActivityData.english_question_has_sub_topic.topic_name +' /' : null}
          
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.sub_topic_name ? 
                                  InnerActivityData.english_question_has_sub_topic.sub_topic_name : null}
                              
                                </p> */}
                                              <div className="mb-0 d-flex align-items-center gap-2">
                                                <p className="mb-0">
                                                  #
                                                  {InnerActivityData.english_question_id
                                                    ? InnerActivityData.english_question_id
                                                    : null}
                                                </p>
                                                <span
                                                  onClick={() =>
                                                    tog_standard(ActivityData1)
                                                  }
                                                >
                                                  <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                                </span>
                                              </div>
                                              {parseInt(customActiveTab) === activeindex + 1 && renderOverlayToggle()}
                                            </div>
                                            <div className="question-container-custom mt-2">
                                              <div className="passage-area flex-fill border">
                                                <div className="d-flex gap-4 mt-3">
                                                {renderSpeakerToggle(
                                                  InnerActivityData?.english_question_id,
                                                  [
                                                    InnerActivityData?.english_question_instruction,
                                                    ...(InnerActivityData?.english_question_choices?.map(
                                                      qusChoice =>
                                                        `${qusChoice.choice_no}. ${qusChoice.choice_text}`
                                                    ) || []),
                                                    InnerActivityData?.english_question_text,
                                                    InnerActivityData?.part_heading,
                                                  ]
                                                )}
                                                <div>
                                                 {InnerActivityData?.english_question_instruction ? <div
                                                  dangerouslySetInnerHTML={{
                                                    __html:
                                                      InnerActivityData.english_question_instruction
                                                        ? InnerActivityData.english_question_instruction
                                                            .replace(
                                                              /\[(\d+)Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                            .replace(
                                                              /\[Answer char=\d+\]/g,
                                                              ""
                                                            )
                                                        : null,
                                                  }}
                                                ></div> : null}

                                                {/* Choice */}
                                                {InnerActivityData &&
                                                InnerActivityData.english_question_choices &&
                                                InnerActivityData
                                                  .english_question_choices
                                                  .length > 0 ? (
                                                  <div className="mt-4 my-2 border border-dark choice-options_wrapper">
                                                    {InnerActivityData.english_question_choices.map(
                                                      (qusChoice, Cindex) => (
                                                        <div
                                                          class="choice-options_child"
                                                          key={Cindex}
                                                        >
                                                          <div>
                                                            {
                                                              qusChoice.choice_no
                                                            }
                                                          </div>
                                                          <div>
                                                            {
                                                              qusChoice.choice_text
                                                            }
                                                          </div>
                                                        </div>
                                                      )
                                                    )}
                                                  </div>
                                                ) : null}

                                                {/* <div className="mt-4" dangerouslySetInnerHTML={{
                                      __html: InnerActivityData.english_question_text ? InnerActivityData.english_question_text.replace(/\[(\d+)Answer char=\d+\]/g, '').replace(/\[Answer char=\d+\]/g, '') : null,
                                    }}>
                                  </div> */}
                                                {InnerActivityData.english_question_text &&
                                                parseInt(
                                                  InnerActivityData.english_question_category_id
                                                ) === 8 ? (
                                                  <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        InnerActivityData.english_question_text
                                                          ? InnerActivityData.english_question_text
                                                              .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /&nbsp;/g,
                                                                ""
                                                              )
                                                              .split("</p>")
                                                              .map(
                                                                (
                                                                  paragraph,
                                                                  index
                                                                ) =>
                                                                  paragraph
                                                                    ? `<div class="d-flex"><p class="me-2">${
                                                                        index +
                                                                        1
                                                                      } ${paragraph}</p></div>`
                                                                    : ""
                                                              )
                                                              .filter(Boolean)
                                                              .join("")
                                                          : null,
                                                    }}
                                                  />
                                                ) : (
                                                  <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        InnerActivityData.english_question_text
                                                          ? InnerActivityData.english_question_text
                                                              .replace(
                                                                /\[(\d+)Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                              .replace(
                                                                /\[Answer char=\d+\]/g,
                                                                ""
                                                              )
                                                          : null,
                                                    }}
                                                  ></div>
                                                )}
                                                {InnerActivityData &&
                                                InnerActivityData.part_heading &&
                                                InnerActivityData.part_heading !=
                                                  "" ? (
                                                  <div
                                                    className="mt-4"
                                                    dangerouslySetInnerHTML={{
                                                      __html:
                                                        InnerActivityData.part_heading,
                                                    }}
                                                  ></div>
                                                ) : null}
                                                {/* File option */}
                                                <div className="mt-4 my-2">
                                                  {InnerActivityData &&
                                                  InnerActivityData.english_question_files &&
                                                  InnerActivityData
                                                    .english_question_files
                                                    .length > 0
                                                    ? InnerActivityData.english_question_files.map(
                                                        (qusFile, imgindex) => (
                                                          <img
                                                            key={imgindex}
                                                            alt=""
                                                            style={{
                                                              height: "auto",
                                                              maxWidth: "100%",
                                                            }}
                                                            src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                                          />
                                                        )
                                                      )
                                                    : null}
                                                </div>
                                              </div>
                                              </div>
                                              </div>
                                              <div className={`question-area flex-fill border long-inputbox cat-${InnerActivityData.english_question_category_id}`}>
                                                {/* Past question */}
                                                {InnerActivityData.english_question_parts &&
                                                  InnerActivityData.english_question_parts.map(
                                                    (quspart, index) => {
                                                      const stuAnswersarray =
                                                        quspart.StudentAnsAttempts.map(
                                                          stuAns => {
                                                            try {
                                                              return JSON.parse(
                                                                stuAns.student_answer
                                                              )
                                                            } catch (error) {
                                                              console.error(
                                                                "Error parsing JSON:",
                                                                error
                                                              )
                                                              return null // or handle the error in an appropriate way
                                                            }
                                                          }
                                                        ) || [] // Extracting session keys

                                                      // Assuming stuAnswersarray is a nested array
                                                      const flattenedStuAnswers =
                                                        [].concat(
                                                          ...stuAnswersarray
                                                        )
                                                      let serialNumber = 0
                                                      let filteredCorrectAns =
                                                        quspart.english_question_answers.filter(
                                                          CorrAns =>
                                                            parseInt(
                                                              CorrAns.english_answer_is_correct
                                                            ) === 1
                                                        )
                                                      return (
                                                        <>
                                                          <div key={index}>
                                                            <div class="d-flex justify-content-between gap-3 mb-3">
                                                              <div className="d-flex gap-2 flex-row ">
                                                                {renderSpeakerToggle("pt" + index, [
                                                                  quspart?.english_question_part_text,
                                                                ])}
                                                                <div className="mr-3">
                                                                  {index + 1}
                                                                  {")"}
                                                                </div>
                                                                <div
                                                                  dangerouslySetInnerHTML={{
                                                                    __html:
                                                                      quspart.english_question_part_text
                                                                        ? quspart.english_question_part_text
                                                                            .replace(
                                                                              /\[(\d+)Answer char=\d+\]/g,
                                                                              ""
                                                                            )
                                                                            .replace(
                                                                              /\[Answer char=\d+\]/g,
                                                                              ""
                                                                            )
                                                                        : null,
                                                                  }}
                                                                ></div>
                                                              </div>
                                                              {(quspart
                                                                .StudentAnsAttempts
                                                                .length > 0 &&
                                                                quspart.english_question_part_automark ==
                                                                  1) ||
                                                              (quspart.english_question_part_automark !=
                                                                1 &&
                                                                ActivityData1.marked_for_manual_marking ==
                                                                  1) ? (
                                                                quspart.markedReport &&
                                                                quspart.markedReport >
                                                                  0 ? (
                                                                  <div>
                                                                    {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                                    <span className="badge bg-warning font-size-12 mt-auto mb-2">
                                                                      Override
                                                                    </span>
                                                                  </div>
                                                                ) : (
                                                                  <div>
                                                                    <i
                                                                      id={`Popover_mark_override_${quspart.english_question_part_id}`}
                                                                      className="mdi mdi-clipboard-check-outline font-size-18"
                                                                      onClick={() =>
                                                                        tog_passcode(
                                                                          ActivityData1,
                                                                          quspart
                                                                        )
                                                                      }
                                                                    ></i>
                                                                    {/* Popover */}
                                                                    {authTutorUser && (
                                                                      <UncontrolledPopover
                                                                        // placement="bottom"
                                                                        trigger="legacy"
                                                                        target={`Popover_mark_override_${quspart.english_question_part_id}`} // Matches button ID
                                                                        isOpen={
                                                                          activePopoverId ===
                                                                          quspart.english_question_part_id
                                                                        } // Only open the popover if its ID matches the active one
                                                                        toggle={() =>
                                                                          togglePopover(
                                                                            quspart.english_question_part_id
                                                                          )
                                                                        } // Toggle popover visibility
                                                                        onClosed={() =>
                                                                          console.log(
                                                                            "close"
                                                                          )
                                                                        } // Custom function when popover is closed
                                                                      >
                                                                        <PopoverBody
                                                                          className="shadow rounded bg-white p-3"
                                                                          style={{
                                                                            width:
                                                                              "300px",
                                                                          }}
                                                                        >
                                                                          <p>
                                                                            <strong>
                                                                              Is
                                                                              the
                                                                              student
                                                                              answer
                                                                              correct?
                                                                            </strong>
                                                                          </p>
                                                                          {/* Yes / No Checkboxes */}
                                                                          <div className="d-flex justify-content-around my-2">
                                                                            <label
                                                                              style={{
                                                                                cursor:
                                                                                  "pointer",
                                                                              }}
                                                                            >
                                                                              <input
                                                                                type="radio"
                                                                                style={{
                                                                                  cursor:
                                                                                    "pointer",
                                                                                }}
                                                                                name={`correct_${quspart.english_question_part_id}`}
                                                                                value="1"
                                                                                checked={
                                                                                  selectedOption ==
                                                                                  "1"
                                                                                }
                                                                                onChange={() => {
                                                                                  if (
                                                                                    quspart.StudentAnsAttempts.every(
                                                                                      attempt =>
                                                                                        attempt.attempt_status ===
                                                                                        1
                                                                                    )
                                                                                  ) {
                                                                                    toast.error(
                                                                                      "Already status correct",
                                                                                      {
                                                                                        autoClose: 3000, // 3 seconds in this example
                                                                                      }
                                                                                    )
                                                                                  } else {
                                                                                    setSelectedOption(
                                                                                      "1"
                                                                                    )
                                                                                    setError(
                                                                                      false
                                                                                    )
                                                                                  }
                                                                                }}
                                                                              />{" "}
                                                                              Yes
                                                                            </label>
                                                                            <label
                                                                              style={{
                                                                                cursor:
                                                                                  "pointer",
                                                                              }}
                                                                            >
                                                                              <input
                                                                                type="radio"
                                                                                style={{
                                                                                  cursor:
                                                                                    "pointer",
                                                                                }}
                                                                                name={`correct_${quspart.english_question_part_id}`}
                                                                                value="0"
                                                                                checked={
                                                                                  selectedOption ==
                                                                                  "0"
                                                                                }
                                                                                onChange={() => {
                                                                                  if (
                                                                                    quspart.StudentAnsAttempts.every(
                                                                                      attempt =>
                                                                                        attempt.attempt_status ===
                                                                                        0
                                                                                    )
                                                                                  ) {
                                                                                    toast.error(
                                                                                      "Already status incorrect",
                                                                                      {
                                                                                        autoClose: 3000, // 3 seconds in this example
                                                                                      }
                                                                                    )
                                                                                  } else {
                                                                                    setSelectedOption(
                                                                                      "0"
                                                                                    )
                                                                                    setError(
                                                                                      false
                                                                                    )
                                                                                  }
                                                                                }}
                                                                                // disabled={}
                                                                              />{" "}
                                                                              No
                                                                            </label>
                                                                          </div>
                                                                          {/* Error message if checkbox is not selected */}
                                                                          {error && (
                                                                            <p className="text-danger text-center">
                                                                              Please
                                                                              select
                                                                              Yes
                                                                              or
                                                                              No
                                                                            </p>
                                                                          )}
                                                                          {(selectedOption ==
                                                                            "1" ||
                                                                            selectedOption ==
                                                                              "0") && (
                                                                            <div className="student-answers mt-3">
                                                                              <h5>
                                                                                Student
                                                                                Answers:
                                                                              </h5>
                                                                              {quspart.english_question_part_answer_type ===
                                                                                8 ||
                                                                              quspart.english_question_part_answer_type ===
                                                                                1 ||
                                                                              quspart.english_question_part_answer_type ===
                                                                                7 ? (
                                                                                <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                                  {quspart.english_question_answers &&
                                                                                    quspart.english_question_answers.map(
                                                                                      (
                                                                                        qusAns,
                                                                                        index1
                                                                                      ) => {
                                                                                        const stuAnswersarray =
                                                                                          quspart.StudentAnsAttempts.filter(
                                                                                            stuAns => {
                                                                                              const attemptStatus =
                                                                                                parseInt(
                                                                                                  stuAns.attempt_status
                                                                                                )
                                                                                              return selectedOption ===
                                                                                                "1"
                                                                                                ? attemptStatus ===
                                                                                                    0
                                                                                                : attemptStatus ===
                                                                                                    1
                                                                                            }
                                                                                          ).flatMap(
                                                                                            stuAns => {
                                                                                              try {
                                                                                                const parsedAnswers =
                                                                                                  JSON.parse(
                                                                                                    stuAns.student_answer
                                                                                                  )
                                                                                                return parsedAnswers.map(
                                                                                                  ans => ({
                                                                                                    ...ans,
                                                                                                    pk_attempt_id:
                                                                                                      stuAns.pk_attempt_id,
                                                                                                  })
                                                                                                )
                                                                                              } catch (error) {
                                                                                                console.error(
                                                                                                  "Error parsing JSON:",
                                                                                                  error
                                                                                                )
                                                                                                return null // or handle the error in an appropriate way
                                                                                              }
                                                                                            }
                                                                                          ) ||
                                                                                          []
                                                                                        const flattenedStuAnswers =
                                                                                          [].concat(
                                                                                            ...stuAnswersarray
                                                                                          )

                                                                                        if (
                                                                                          qusAns.english_answer_is_correct ===
                                                                                          1
                                                                                        ) {
                                                                                          let filteredAllStuAns =
                                                                                            flattenedStuAnswers.filter(
                                                                                              stuAns =>
                                                                                                parseInt(
                                                                                                  stuAns.part_id
                                                                                                ) ===
                                                                                                  parseInt(
                                                                                                    qusAns.english_answer_part_id
                                                                                                  ) &&
                                                                                                parseInt(
                                                                                                  stuAns.answer_id
                                                                                                ) ===
                                                                                                  parseInt(
                                                                                                    qusAns.english_answer_id
                                                                                                  )
                                                                                            ) ||
                                                                                            []

                                                                                          return (
                                                                                            <div
                                                                                              key={
                                                                                                index1
                                                                                              }
                                                                                              className="student-answers mt-3"
                                                                                            >
                                                                                              <ul className="list-group">
                                                                                                {filteredAllStuAns
                                                                                                  .reverse()
                                                                                                  .map(
                                                                                                    (
                                                                                                      item,
                                                                                                      idx
                                                                                                    ) => (
                                                                                                      <>
                                                                                                        <li
                                                                                                          className="list-group-item align-items-center gap-1 ps-2 mb-2"
                                                                                                          key={`${idx}_answer${item.pk_attempt_id}`}
                                                                                                          onClick={() => {
                                                                                                            setSelectedStudentAnswer(
                                                                                                              item.answer_id
                                                                                                            )
                                                                                                            setSelectedAttemptId(
                                                                                                              item.pk_attempt_id
                                                                                                            )
                                                                                                            setansError(
                                                                                                              false
                                                                                                            )
                                                                                                            console.log(
                                                                                                              item
                                                                                                            )
                                                                                                          }}
                                                                                                          style={{
                                                                                                            cursor:
                                                                                                              "pointer",
                                                                                                          }}
                                                                                                        >
                                                                                                          <div className="d-flex align-items-center gap-1">
                                                                                                            <input
                                                                                                              type="radio"
                                                                                                              name={`selected_answer_${idx}${item.pk_attempt_id}`}
                                                                                                              value={
                                                                                                                item.answer_id
                                                                                                              }
                                                                                                              checked={
                                                                                                                selectedAttemptId ===
                                                                                                                item.pk_attempt_id
                                                                                                              }
                                                                                                              onClick={() => {
                                                                                                                setSelectedStudentAnswer(
                                                                                                                  item.answer_id
                                                                                                                )
                                                                                                                setSelectedAttemptId(
                                                                                                                  item.pk_attempt_id
                                                                                                                )
                                                                                                                setansError(
                                                                                                                  false
                                                                                                                )
                                                                                                              }}
                                                                                                            />
                                                                                                            {
                                                                                                              item.text
                                                                                                            }
                                                                                                          </div>
                                                                                                        </li>
                                                                                                      </>
                                                                                                    )
                                                                                                  )}
                                                                                              </ul>
                                                                                            </div>
                                                                                          )
                                                                                        }
                                                                                      }
                                                                                    )}
                                                                                </ul>
                                                                              ) : quspart.english_question_part_answer_type ===
                                                                                4 ? (
                                                                                //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                                                <ul className="list-group">
                                                                                  {quspart
                                                                                    .StudentAnsAttempts
                                                                                    .length >
                                                                                  0 ? (
                                                                                    quspart.StudentAnsAttempts.filter(
                                                                                      stuAns => {
                                                                                        const attemptStatus =
                                                                                          parseInt(
                                                                                            stuAns.attempt_status
                                                                                          )
                                                                                        return selectedOption ===
                                                                                          "1"
                                                                                          ? attemptStatus ===
                                                                                              0
                                                                                          : attemptStatus ===
                                                                                              1
                                                                                      }
                                                                                    ).map(
                                                                                      (
                                                                                        stuAns,
                                                                                        index
                                                                                      ) => {
                                                                                        const studentAnswer =
                                                                                          JSON.parse(
                                                                                            stuAns.student_answer
                                                                                          )
                                                                                        const flatStuAnswers =
                                                                                          [].concat(
                                                                                            ...studentAnswer
                                                                                          )

                                                                                        const filterStuAns =
                                                                                          flatStuAnswers.filter(
                                                                                            stuAns =>
                                                                                              quspart?.english_question_answers?.some(
                                                                                                answer =>
                                                                                                  parseInt(
                                                                                                    stuAns.part_id
                                                                                                  ) ===
                                                                                                    parseInt(
                                                                                                      answer.english_answer_part_id
                                                                                                    ) &&
                                                                                                  parseInt(
                                                                                                    stuAns.answer_id
                                                                                                  ) ===
                                                                                                    parseInt(
                                                                                                      answer.english_answer_id
                                                                                                    )
                                                                                              )
                                                                                          ) ||
                                                                                          []

                                                                                        return filterStuAns.length >
                                                                                          0
                                                                                          ? filterStuAns.map(
                                                                                              (
                                                                                                filteredAns,
                                                                                                filteredIndex
                                                                                              ) => {
                                                                                                return (
                                                                                                  <>
                                                                                                    <li
                                                                                                      className="list-group-item"
                                                                                                      key={`${index}_${filteredIndex}`}
                                                                                                    >
                                                                                                      <div
                                                                                                        className="d-flex align-items-center gap-1"
                                                                                                        onClick={() => {
                                                                                                          setSelectedStudentAnswer(
                                                                                                            filteredAns.answer_id
                                                                                                          )
                                                                                                          setSelectedAttemptId(
                                                                                                            stuAns.pk_attempt_id
                                                                                                          )
                                                                                                          setansError(
                                                                                                            false
                                                                                                          )
                                                                                                        }}
                                                                                                        style={{
                                                                                                          cursor:
                                                                                                            "pointer",
                                                                                                        }}
                                                                                                      >
                                                                                                        {/* Allow user to select the answer */}
                                                                                                        <input
                                                                                                          type="radio"
                                                                                                          name={`selected_answer_${index}`}
                                                                                                          value={
                                                                                                            filteredAns.answer_id
                                                                                                          }
                                                                                                          checked={
                                                                                                            selectedStudentAnswer ===
                                                                                                            filteredAns.answer_id
                                                                                                          }
                                                                                                          onChange={() => {
                                                                                                            setSelectedStudentAnswer(
                                                                                                              filteredAns.answer_id
                                                                                                            )
                                                                                                            setSelectedAttemptId(
                                                                                                              stuAns.pk_attempt_id
                                                                                                            )
                                                                                                            setansError(
                                                                                                              false
                                                                                                            )
                                                                                                          }}
                                                                                                        />
                                                                                                        <div
                                                                                                          dangerouslySetInnerHTML={{
                                                                                                            __html:
                                                                                                              filteredAns.text ||
                                                                                                              "No answer provided",
                                                                                                          }}
                                                                                                        ></div>
                                                                                                      </div>
                                                                                                    </li>
                                                                                                  </>
                                                                                                )
                                                                                              }
                                                                                            )
                                                                                          : null
                                                                                      }
                                                                                    )
                                                                                  ) : (
                                                                                    <li className="list-group-item">
                                                                                      No
                                                                                      student
                                                                                      answers
                                                                                      available
                                                                                    </li>
                                                                                  )}
                                                                                </ul>
                                                                              ) : (
                                                                                <p className="text-center">
                                                                                  No
                                                                                  option
                                                                                </p>
                                                                              )}
                                                                              {anserror && (
                                                                                <p className="text-danger text-center">
                                                                                  Please
                                                                                  select
                                                                                  the
                                                                                  correct
                                                                                  answer
                                                                                </p>
                                                                              )}
                                                                            </div>
                                                                          )}
                                                                          {/* Feedback Textarea */}
                                                                          <textarea
                                                                            className="form-control my-2"
                                                                            placeholder="Enter feedback..."
                                                                            value={
                                                                              feedback
                                                                            }
                                                                            onChange={e =>
                                                                              setFeedback(
                                                                                e
                                                                                  .target
                                                                                  .value
                                                                              )
                                                                            }
                                                                          ></textarea>

                                                                          {/* Buttons */}
                                                                          <div className="d-flex justify-content-between mt-3">
                                                                            <button
                                                                              className="btn btn-secondary btn-sm"
                                                                              onClick={() =>
                                                                                setActivePopoverId(
                                                                                  null
                                                                                )
                                                                              }
                                                                            >
                                                                              Cancel
                                                                            </button>
                                                                            <button
                                                                              className="btn btn-primary btn-sm"
                                                                              onClick={
                                                                                handleSubmit
                                                                              }
                                                                            >
                                                                              Submit
                                                                            </button>
                                                                          </div>
                                                                        </PopoverBody>
                                                                      </UncontrolledPopover>
                                                                    )}
                                                                  </div>
                                                                )
                                                              ) : null}
                                                            </div>
                                                            {/* Anse category statement Star */}
                                                            {quspart.english_question_part_answer_type ===
                                                              8 ||
                                                            quspart.english_question_part_answer_type ===
                                                              1 ||
                                                            quspart.english_question_part_answer_type ===
                                                              7 ? (
                                                              <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                {" "}
                                                                {parseInt(
                                                                  quspart.english_question_part_automark
                                                                ) === 1 ? (
                                                                  ""
                                                                ) : (
                                                                  <div className="d-flex justify-content-end">
                                                                    <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                      Manual
                                                                      Marking
                                                                    </span>
                                                                  </div>
                                                                )}
                                                                {quspart.english_question_answers &&
                                                                  quspart.english_question_answers.map(
                                                                    (
                                                                      qusAns,
                                                                      index1
                                                                    ) => {
                                                                      // Your logic for filtering student answers and determining status_color and border_color
                                                                      const stuAnswersarray =
                                                                        quspart.StudentAnsAttempts.map(
                                                                          stuAns => {
                                                                            try {
                                                                              return JSON.parse(
                                                                                stuAns.student_answer
                                                                              )
                                                                            } catch (error) {
                                                                              console.error(
                                                                                "Error parsing JSON:",
                                                                                error
                                                                              )
                                                                              return null // or handle the error in an appropriate way
                                                                            }
                                                                          }
                                                                        ) || [] // Extracting session keys
                                                                      //console.log(stuAnswersarray);
                                                                      // Assuming stuAnswersarray is a nested array
                                                                      const flattenedStuAnswers =
                                                                        [].concat(
                                                                          ...stuAnswersarray
                                                                        )
                                                                      let cleanedText =
                                                                        qusAns.english_answer_text
                                                                          .replace(
                                                                            /&nbsp;/g,
                                                                            ""
                                                                          )
                                                                          .replace(
                                                                            /`/g,
                                                                            ""
                                                                          )
                                                                          .replace(
                                                                            /<[^>]*>/g,
                                                                            ""
                                                                          ) ||
                                                                        ""
                                                                      let resultTest =
                                                                        cleanedText
                                                                          .toLowerCase()
                                                                          .trim()
                                                                      let answers =
                                                                        resultTest.split(
                                                                          "|"
                                                                        ) || []
                                                                      let firstAnswer =
                                                                        answers[0]
                                                                          ? answers[0].trim()
                                                                          : ""
                                                                      let secondAnswer =
                                                                        answers[1]
                                                                          ? answers[1].trim()
                                                                          : ""

                                                                      let answersArray =
                                                                        cleanedText
                                                                          .split(
                                                                            "|"
                                                                          )
                                                                          .map(
                                                                            ans =>
                                                                              ans
                                                                                .trim()
                                                                                .toLowerCase()
                                                                          )
                                                                          .filter(
                                                                            Boolean
                                                                          ) ||
                                                                        []

                                                                      if (
                                                                        qusAns.english_answer_is_correct ===
                                                                        1
                                                                      ) {
                                                                        let filteredStuAns =
                                                                          flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                              parseInt(
                                                                                stuAns.part_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.english_answer_part_id
                                                                                ) &&
                                                                              (stuAns.text
                                                                                .toLowerCase()
                                                                                .trim() ==
                                                                                resultTest ||
                                                                                stuAns.text
                                                                                  .toLowerCase()
                                                                                  .trim() ==
                                                                                  firstAnswer ||
                                                                                stuAns.text
                                                                                  .toLowerCase()
                                                                                  .trim() ==
                                                                                  secondAnswer ||
                                                                                answersArray.some(
                                                                                  answer =>
                                                                                    answer ==
                                                                                    stuAns.text
                                                                                      .toLowerCase()
                                                                                      .trim()
                                                                                )) &&
                                                                              parseInt(
                                                                                stuAns.answer_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.english_answer_id
                                                                                )
                                                                          ) ||
                                                                          []

                                                                        let filteredAllStuAns =
                                                                          flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                              parseInt(
                                                                                stuAns.part_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.english_answer_part_id
                                                                                ) &&
                                                                              parseInt(
                                                                                stuAns.answer_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.english_answer_id
                                                                                )
                                                                          ) ||
                                                                          []

                                                                        return (
                                                                          <li
                                                                            key={
                                                                              index1
                                                                            }
                                                                            className={
                                                                              parseInt(
                                                                                quspart.english_question_part_automark
                                                                              ) ===
                                                                              1
                                                                                ? filteredStuAns.length >
                                                                                  0
                                                                                  ? "input_box e_input_box"
                                                                                  : "input_box e_input_box"
                                                                                : " input_box e_input_box"
                                                                            }
                                                                          >
                                                                            {parseInt(
                                                                              InnerActivityData?.english_question_category_id
                                                                            ) ===
                                                                            2 ? (
                                                                              <textarea
                                                                                id={
                                                                                  index1 +
                                                                                  Math.floor(
                                                                                    Math.random() *
                                                                                      5
                                                                                  )
                                                                                }
                                                                                className={
                                                                                  parseInt(
                                                                                    quspart.english_question_part_automark
                                                                                  ) ===
                                                                                  1
                                                                                    ? (filteredStuAns.length >
                                                                                        0 &&
                                                                                        !quspart?.markedReport >
                                                                                          0) ||
                                                                                      (quspart?.markedReport >
                                                                                        0 &&
                                                                                        quspart.StudentAnsAttempts.some(
                                                                                          attempt =>
                                                                                            parseInt(
                                                                                              attempt.attempt_status
                                                                                            ) ==
                                                                                            1
                                                                                        ))
                                                                                      ? "answersuccess"
                                                                                      : "answererror "
                                                                                    : quspart
                                                                                        .StudentAnsAttempts
                                                                                        .length >
                                                                                        0 &&
                                                                                      quspart.english_question_part_automark ==
                                                                                        0 &&
                                                                                      ActivityData1.marked_for_manual_marking ==
                                                                                        1
                                                                                    ? quspart
                                                                                        .StudentAnsAttempts[0]
                                                                                        .attempt_status ==
                                                                                      1
                                                                                      ? "answersuccess"
                                                                                      : "answererror"
                                                                                    : "answereditor"
                                                                                }
                                                                                value={
                                                                                  filteredAllStuAns
                                                                                    .filter(
                                                                                      item =>
                                                                                        parseInt(
                                                                                          item.answer_id
                                                                                        ) ===
                                                                                        parseInt(
                                                                                          qusAns.english_answer_id
                                                                                        )
                                                                                    )
                                                                                    .reverse()
                                                                                    .map(
                                                                                      item =>
                                                                                        item.text
                                                                                    )
                                                                                    .find(
                                                                                      text =>
                                                                                        text !==
                                                                                        undefined
                                                                                    ) ||
                                                                                  "" // Find the first non-undefined text value
                                                                                }
                                                                                disabled={
                                                                                  true
                                                                                }
                                                                                //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                onChange={e =>
                                                                                  handletext(
                                                                                    e,
                                                                                    qusAns.english_answer_id,
                                                                                    qusAns.english_answer_part_id
                                                                                  )
                                                                                }
                                                                                // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                              />
                                                                            ) : (
                                                                              <textarea
                                                                                id={
                                                                                  index1 +
                                                                                  Math.floor(
                                                                                    Math.random() *
                                                                                      5
                                                                                  )
                                                                                }
                                                                                // type="text"
                                                                                className={
                                                                                  parseInt(
                                                                                    quspart.english_question_part_automark
                                                                                  ) ===
                                                                                  1
                                                                                    ? (filteredStuAns.length >
                                                                                        0 &&
                                                                                        !quspart?.markedReport >
                                                                                          0) ||
                                                                                      (quspart?.markedReport >
                                                                                        0 &&
                                                                                        quspart.StudentAnsAttempts.some(
                                                                                          attempt =>
                                                                                            parseInt(
                                                                                              attempt.attempt_status
                                                                                            ) ==
                                                                                            1
                                                                                        ))
                                                                                      ? "answersuccess"
                                                                                      : "answererror "
                                                                                    : quspart
                                                                                        .StudentAnsAttempts
                                                                                        .length >
                                                                                        0 &&
                                                                                      quspart.english_question_part_automark ==
                                                                                        0 &&
                                                                                      ActivityData1.marked_for_manual_marking ==
                                                                                        1
                                                                                    ? quspart
                                                                                        .StudentAnsAttempts[0]
                                                                                        .attempt_status ==
                                                                                      1
                                                                                      ? "answersuccess"
                                                                                      : "answererror"
                                                                                    : "answereditor"
                                                                                }
                                                                                value={
                                                                                  filteredAllStuAns
                                                                                    .filter(
                                                                                      item =>
                                                                                        parseInt(
                                                                                          item.answer_id
                                                                                        ) ===
                                                                                        parseInt(
                                                                                          qusAns.english_answer_id
                                                                                        )
                                                                                    )
                                                                                    .reverse()
                                                                                    .map(
                                                                                      item =>
                                                                                        item.text
                                                                                    )
                                                                                    .find(
                                                                                      text =>
                                                                                        text !==
                                                                                        undefined
                                                                                    ) ||
                                                                                  "" // Find the first non-undefined text value
                                                                                }
                                                                                disabled={
                                                                                  true
                                                                                }
                                                                                //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                                onChange={e =>
                                                                                  handletext(
                                                                                    e,
                                                                                    qusAns.english_answer_id,
                                                                                    qusAns.english_answer_part_id
                                                                                  )
                                                                                }
                                                                                // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                              />
                                                                            )}
                                                                          </li>
                                                                        )
                                                                      }
                                                                    }
                                                                  )}
                                                              </ul>
                                                            ) : quspart.english_question_part_answer_type ===
                                                              4 ? (
                                                              //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                              <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                                                {parseInt(
                                                                  quspart.english_question_part_automark
                                                                ) === 1 ? (
                                                                  ""
                                                                ) : (
                                                                  <div className="d-flex justify-content-end">
                                                                    <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                      Manual
                                                                      Marking
                                                                    </span>
                                                                  </div>
                                                                )}
                                                                {quspart.english_question_answers &&
                                                                  rearrangeEvenOdd(
                                                                    quspart.english_question_answers
                                                                  ).map(
                                                                    (
                                                                      qusAns,
                                                                      index1
                                                                    ) => {
                                                                      const cleanText =
                                                                        qusAns.english_answer_text
                                                                          .replace(
                                                                            /&nbsp;/g,
                                                                            ""
                                                                          )
                                                                          .replace(
                                                                            /`/g,
                                                                            ""
                                                                          )
                                                                          .replace(
                                                                            /<[^>]*>/g,
                                                                            ""
                                                                          )
                                                                          .trim()

                                                                      const hasImage =
                                                                        /<img\s+[^>]*>/gi.test(
                                                                          qusAns.english_answer_text
                                                                        )

                                                                      if (
                                                                        !cleanText &&
                                                                        !hasImage
                                                                      ) {
                                                                        return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                      }
                                                                      serialNumber++
                                                                      let filteredStuAns =
                                                                        flattenedStuAnswers.filter(
                                                                          stuAns =>
                                                                            parseInt(
                                                                              stuAns.part_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_part_id
                                                                              ) &&
                                                                            parseInt(
                                                                              stuAns.answer_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_id
                                                                              )
                                                                        ) || []

                                                                      //OverRide check status start
                                                                      let filteredStuAnsoverridedata =
                                                                        quspart.StudentAnsAttempts.filter(
                                                                          stuAns =>
                                                                            parseInt(
                                                                              stuAns.attempt_status
                                                                            ) ===
                                                                            1
                                                                        ) || []
                                                                      const stuAnswersoverridearray =
                                                                        filteredStuAnsoverridedata.map(
                                                                          stuAns => {
                                                                            try {
                                                                              return JSON.parse(
                                                                                stuAns.student_answer
                                                                              )
                                                                            } catch (error) {
                                                                              console.error(
                                                                                "Error parsing JSON:",
                                                                                error
                                                                              )
                                                                              return null // or handle the error in an appropriate way
                                                                            }
                                                                          }
                                                                        ) || []
                                                                      const flattenedoverrideStuAnswers =
                                                                        [].concat(
                                                                          ...stuAnswersoverridearray
                                                                        )

                                                                      let filteredStuAnsoverride =
                                                                        flattenedoverrideStuAnswers.filter(
                                                                          stuAns =>
                                                                            parseInt(
                                                                              stuAns.part_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_part_id
                                                                              ) &&
                                                                            parseInt(
                                                                              stuAns.answer_id
                                                                            ) ===
                                                                              parseInt(
                                                                                qusAns.english_answer_id
                                                                              )
                                                                        ) || []

                                                                      //OverRide check status end
                                                                      var status_color =
                                                                        "selector-general cursor-pointer"
                                                                      var border_color =
                                                                        "border-start-secondary"
                                                                      if (
                                                                        filteredStuAns.length >
                                                                          0 &&
                                                                        parseInt(
                                                                          quspart.english_question_part_automark
                                                                        ) === 1
                                                                      ) {
                                                                        if (
                                                                          parseInt(
                                                                            qusAns.english_answer_is_correct
                                                                          ) ===
                                                                            1 &&
                                                                          !quspart?.markedReport >
                                                                            0
                                                                        ) {
                                                                          status_color =
                                                                            "selector-success"
                                                                          border_color =
                                                                            "border-start-success"
                                                                        } else if (
                                                                          filteredStuAnsoverride.length >
                                                                            0 &&
                                                                          quspart.markedReport >
                                                                            0
                                                                        ) {
                                                                          status_color =
                                                                            "selector-success"
                                                                          border_color =
                                                                            "border-start-success"
                                                                        } else {
                                                                          status_color =
                                                                            "selector-wrong "
                                                                          border_color =
                                                                            "border-start-danger"
                                                                        }
                                                                      } else if (
                                                                        quspart
                                                                          .StudentAnsAttempts
                                                                          .length >
                                                                          0 &&
                                                                        quspart.english_question_part_automark ==
                                                                          0 &&
                                                                        ActivityData1.marked_for_manual_marking ==
                                                                          1
                                                                      ) {
                                                                        if (
                                                                          quspart
                                                                            .StudentAnsAttempts[0]
                                                                            .attempt_status ==
                                                                          1
                                                                        ) {
                                                                          status_color =
                                                                            "selector-success"
                                                                          border_color =
                                                                            "border-start-success"
                                                                        } else {
                                                                          status_color =
                                                                            "selector-wrong "
                                                                          border_color =
                                                                            "border-start-danger"
                                                                        }
                                                                      }
                                                                      //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                      return (
                                                                        <li
                                                                          className={
                                                                            status_color +
                                                                            " choose e_choose"
                                                                          }
                                                                          key={
                                                                            index1
                                                                          }
                                                                        >
                                                                          <div
                                                                            style={{
                                                                              position: "absolute",
                                                                              left: "-40px",
                                                                              top: "50%",
                                                                              transform: "translateY(-50%)",
                                                                            }}
                                                                            onClick={e => e.stopPropagation()}
                                                                          >
                                                                            {renderSpeakerToggle(
                                                                              "ans-" + qusAns.english_answer_id,
                                                                              [qusAns.english_answer_text]
                                                                            )}
                                                                          </div>
                                                                          <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                                                            <span className="dg-serial-badge">{serialNumber}</span>
                                                                          </div>
                                                                          <div
                                                                            className={
                                                                              "p-2 dg-media " +
                                                                              {
                                                                                border_color,
                                                                              }
                                                                            }
                                                                            dangerouslySetInnerHTML={{
                                                                              __html:
                                                                                qusAns.english_answer_text
                                                                                  ? qusAns.english_answer_text
                                                                                  : null,
                                                                            }}
                                                                          ></div>
                                                                        </li>
                                                                      )
                                                                    }
                                                                  )}
                                                              </ul>
                                                            ) : (
                                                              <p className="text-center">
                                                                No option
                                                              </p>
                                                            )}
                                                            {/* Anse category statement end */}
                                                          </div>
                                                          {quspart
                                                            ?.StudentQusSkip
                                                            ?.length === 0 ? (
                                                            <div className="mb-3">
                                                              <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                                Solution
                                                              </h4>
                                                              {filteredCorrectAns.map(
                                                                (
                                                                  qusAns,
                                                                  index1
                                                                ) => {
                                                                  return (
                                                                    <div
                                                                      className="e_feedBack"
                                                                      style={{
                                                                        border:
                                                                          "1px solid #1a1a1a",
                                                                        borderRadius:
                                                                          "4px",
                                                                        fontSize:
                                                                          "16px",
                                                                      }}
                                                                    >
                                                                      <div
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            qusAns.english_answer_text
                                                                              ? qusAns.english_answer_text
                                                                              : null,
                                                                        }}
                                                                      ></div>
                                                                    </div>
                                                                  )
                                                                }
                                                              )}
                                                            </div>
                                                          ) : null}
                                                        </>
                                                      )
                                                    }
                                                  )}

                                                {/* past question End */}
                                              </div>
                                            </div>
                                          </li>
                                        </ul>

                                        <div className={'action-btns d-flex gap-4 mt-2'+ (activeindex + 1 > 1 ? ' justify-content-between' : ' justify-content-end')}>
                                          {/* Render a "Prev" button if the active index is greater than 0 */}
                                          {activeindex + 1 > 1 ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(activeindex)
                                              }}
                                            >
                                              Prev
                                            </Button>
                                          ) : null}

                                          {/* Render a "Next" button if the active index is less than the total length of LessonActivitiesQuestions array */}
                                          {activeindex + 1 <
                                          ActivityData.LessonActivitiesQuestions
                                            .length ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(
                                                  activeindex + 1 + 1
                                                )
                                              }}
                                            >
                                              Next
                                            </Button>
                                          ) : null}
                                        </div>
                                      </div>
                                    </TabPane>
                                  )
                                } else if (
                                  InnerActivityData &&
                                  InnerActivityData.english_question_category_id &&
                                  (parseInt(
                                    InnerActivityData.english_question_category_id
                                  ) === 13 ||
                                    parseInt(
                                      InnerActivityData.english_question_category_id
                                    ) === 10)
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div
                                        style={getOverlayCardStyle()}
                                        className={`hw-list mt-4 pb-2 not_scroll ${
                                          localStorage.getItem("is_fontsize") ==
                                          1
                                            ? "stu-custom-font-size"
                                            : ""
                                        }`}
                                      >
                                        <ul className="list-unstyled mb-0 question_container nv-scrollbar">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end nv-sticky-header">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.level_name ? 
                                  InnerActivityData.english_question_has_sub_topic.level_name +' /' : null}
                                  
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.strand_name ? 
                                  InnerActivityData.english_question_has_sub_topic.strand_name +' /' : null}
          
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.topic_name ? 
                                  InnerActivityData.english_question_has_sub_topic.topic_name +' /' : null}
          
                                  {InnerActivityData.english_question_has_sub_topic && InnerActivityData.english_question_has_sub_topic.sub_topic_name ? 
                                  InnerActivityData.english_question_has_sub_topic.sub_topic_name : null}
                              
                                </p> */}
                                            <div className="mb-0 d-flex align-items-center gap-2">
                                              <p className="mb-0">
                                                #
                                                {InnerActivityData.english_question_id
                                                  ? InnerActivityData.english_question_id
                                                  : null}
                                              </p>
                                              <span
                                                onClick={() =>
                                                  tog_standard(ActivityData1)
                                                }
                                              >
                                                <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                              </span>
                                            </div>
                                            {parseInt(customActiveTab) === activeindex + 1 && renderOverlayToggle()}
                                          </div>
                                          <div className="d-flex gap-3 mt-2">
                                            {renderSpeakerToggle(InnerActivityData?.english_question_id, [
                                              InnerActivityData?.english_question_instruction,
                                              ...(InnerActivityData?.english_question_choices?.map(
                                                qusChoice =>
                                                  `${qusChoice.choice_no}. ${qusChoice.choice_text}`
                                              ) || []),
                                              InnerActivityData?.english_question_text,
                                              InnerActivityData?.part_heading,
                                            ])}
                                            <div>
                                            {InnerActivityData?.english_question_instruction ?<div
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  InnerActivityData.english_question_instruction
                                                    ? InnerActivityData.english_question_instruction
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                    : null,
                                              }}
                                            ></div>: null}
                                            {/* Choice */}
                                            {InnerActivityData &&
                                            InnerActivityData.english_question_choices &&
                                            InnerActivityData
                                              .english_question_choices.length >
                                              0 ? (
                                              <div className="mt-4 my-2 border border-dark choice-options_wrapper">
                                                {InnerActivityData.english_question_choices.map(
                                                  (qusChoice, Cindex) => (
                                                    <div
                                                      class="choice-options_child"
                                                      key={Cindex}
                                                    >
                                                      <div>
                                                        {qusChoice.choice_no}
                                                      </div>
                                                      <div>
                                                        {qusChoice.choice_text}
                                                      </div>
                                                    </div>
                                                  )
                                                )}
                                              </div>
                                            ) : null}

                                            <div
                                              className="mt-4"
                                              dangerouslySetInnerHTML={{
                                                __html:
                                                  InnerActivityData.english_question_text
                                                    ? InnerActivityData.english_question_text
                                                        .replace(
                                                          /\[(\d+)Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                        .replace(
                                                          /\[Answer char=\d+\]/g,
                                                          ""
                                                        )
                                                    : null,
                                              }}
                                            ></div>
                                            {InnerActivityData &&
                                            InnerActivityData.part_heading &&
                                            InnerActivityData.part_heading !=
                                              "" ? (
                                              <div
                                                className="mt-4"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    InnerActivityData.part_heading,
                                                }}
                                              ></div>
                                            ) : null}
                                            {/* File option */}
                                            <div className="mt-4 my-2">
                                              {InnerActivityData &&
                                              InnerActivityData.english_question_files &&
                                              InnerActivityData
                                                .english_question_files.length >
                                                0
                                                ? InnerActivityData.english_question_files.map(
                                                    (qusFile, imgindex) => (
                                                      <img
                                                        key={imgindex}
                                                        alt=""
                                                        style={{
                                                          height: "auto",
                                                          maxWidth: "100%",
                                                        }}
                                                        src={`https://s3.ap-southeast-1.amazonaws.com/assets-dev.mygooroo.io/question_files/${qusFile.file_name}`}
                                                      />
                                                    )
                                                  )
                                                : null}
                                            </div>
                                            </div>
                                            </div>

                                            {/* Past question */}
                                            {InnerActivityData.english_question_parts &&
                                              InnerActivityData.english_question_parts.map(
                                                (quspart, index) => {
                                                  if (
                                                    quspart.english_question_answers &&
                                                    quspart
                                                      .english_question_answers
                                                      .length > 0 &&
                                                    quspart
                                                      .english_question_answers[0]
                                                      .english_answer_text &&
                                                    quspart
                                                      .english_question_answers[0]
                                                      .english_answer_text != ""
                                                  ) {
                                                    const stuAnswersarray =
                                                      quspart.StudentAnsAttempts.map(
                                                        stuAns => {
                                                          try {
                                                            return JSON.parse(
                                                              stuAns.student_answer
                                                            )
                                                          } catch (error) {
                                                            console.error(
                                                              "Error parsing JSON:",
                                                              error
                                                            )
                                                            return null // or handle the error in an appropriate way
                                                          }
                                                        }
                                                      ) || [] // Extracting session keys

                                                    // Assuming stuAnswersarray is a nested array
                                                    const flattenedStuAnswers =
                                                      [].concat(
                                                        ...stuAnswersarray
                                                      )
                                                    let serialNumber = 0
                                                    return (
                                                      <div
                                                        key={index}
                                                        className="d-flex justify-content-between align-items-center mt-3"
                                                      >
                                                        <div class="d-flex justify-content-between gap-3 mb-3">
                                                          <div className="d-flex gap-2 flex-row ">
                                                            {/* <div className="mr-3">{index + 1}</div> */}
                                                            {renderSpeakerToggle("pt" + index, [
                                                              quspart.english_question_part_text,
                                                            ])}
                                                            <div
                                                              dangerouslySetInnerHTML={{
                                                                __html:
                                                                  quspart.english_question_part_text
                                                                    ? quspart.english_question_part_text
                                                                        .replace(
                                                                          /\[\[(.+?)\]\]/g,
                                                                          function (
                                                                            match,
                                                                            p1
                                                                          ) {
                                                                            return p1.length >
                                                                              1
                                                                              ? `<span class="text-bg-yellow">${p1}</span>`
                                                                              : `<span class="text-bg-blue">${p1}</span>`
                                                                          }
                                                                        )
                                                                        .replace(
                                                                          /\{\{/g,
                                                                          "<u>"
                                                                        )
                                                                        .replace(
                                                                          /\}\}/g,
                                                                          "</u>"
                                                                        )
                                                                        .replace(
                                                                          /\[(\d+)Answer char=\d+\]/g,
                                                                          ""
                                                                        )
                                                                        .replace(
                                                                          /\[Answer char=\d+\]/g,
                                                                          ""
                                                                        )
                                                                    : null,
                                                              }}
                                                            ></div>
                                                          </div>
                                                          {(quspart
                                                            .StudentAnsAttempts
                                                            .length > 0 &&
                                                            quspart.english_question_part_automark ==
                                                              1) ||
                                                          (quspart.english_question_part_automark !=
                                                            1 &&
                                                            ActivityData1.marked_for_manual_marking ==
                                                              1) ? (
                                                            quspart.markedReport &&
                                                            quspart.markedReport >
                                                              0 ? (
                                                              <div>
                                                                {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                                <span className="badge bg-warning font-size-12 mt-auto mb-2">
                                                                  Override
                                                                </span>
                                                              </div>
                                                            ) : (
                                                              <div>
                                                                <i
                                                                  id={`Popover_mark_override_${quspart.english_question_part_id}`}
                                                                  className="mdi mdi-clipboard-check-outline font-size-18"
                                                                  onClick={() =>
                                                                    tog_passcode(
                                                                      ActivityData1,
                                                                      quspart
                                                                    )
                                                                  }
                                                                ></i>
                                                                {/* Popover */}
                                                                {authTutorUser && (
                                                                  <UncontrolledPopover
                                                                    //placement="bottom"
                                                                    trigger="legacy"
                                                                    target={`Popover_mark_override_${quspart.english_question_part_id}`} // Matches button ID
                                                                    isOpen={
                                                                      activePopoverId ===
                                                                      quspart.english_question_part_id
                                                                    } // Only open the popover if its ID matches the active one
                                                                    toggle={() =>
                                                                      togglePopover(
                                                                        quspart.english_question_part_id
                                                                      )
                                                                    } // Toggle popover visibility
                                                                    onClosed={() =>
                                                                      console.log(
                                                                        "close"
                                                                      )
                                                                    } // Custom function when popover is closed
                                                                  >
                                                                    <PopoverBody
                                                                      className="shadow rounded bg-white p-3"
                                                                      style={{
                                                                        width:
                                                                          "300px",
                                                                      }}
                                                                    >
                                                                      <p>
                                                                        <strong>
                                                                          Is the
                                                                          student
                                                                          answer
                                                                          correct?
                                                                        </strong>
                                                                      </p>
                                                                      {/* Yes / No Checkboxes */}
                                                                      <div className="d-flex justify-content-around my-2">
                                                                        <label
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                        >
                                                                          <input
                                                                            type="radio"
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                            }}
                                                                            name={`correct_${quspart.english_question_part_id}`}
                                                                            value="1"
                                                                            checked={
                                                                              selectedOption ==
                                                                              "1"
                                                                            }
                                                                            onChange={() => {
                                                                              if (
                                                                                quspart.StudentAnsAttempts.every(
                                                                                  attempt =>
                                                                                    attempt.attempt_status ===
                                                                                    1
                                                                                )
                                                                              ) {
                                                                                toast.error(
                                                                                  "Already status correct",
                                                                                  {
                                                                                    autoClose: 3000, // 3 seconds in this example
                                                                                  }
                                                                                )
                                                                              } else {
                                                                                setSelectedOption(
                                                                                  "1"
                                                                                )
                                                                                setError(
                                                                                  false
                                                                                )
                                                                              }
                                                                            }}
                                                                          />{" "}
                                                                          Yes
                                                                        </label>
                                                                        <label
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                        >
                                                                          <input
                                                                            type="radio"
                                                                            style={{
                                                                              cursor:
                                                                                "pointer",
                                                                            }}
                                                                            name={`correct_${quspart.english_question_part_id}`}
                                                                            value="0"
                                                                            checked={
                                                                              selectedOption ==
                                                                              "0"
                                                                            }
                                                                            onChange={() => {
                                                                              if (
                                                                                quspart.StudentAnsAttempts.every(
                                                                                  attempt =>
                                                                                    attempt.attempt_status ===
                                                                                    0
                                                                                )
                                                                              ) {
                                                                                toast.error(
                                                                                  "Already status incorrect",
                                                                                  {
                                                                                    autoClose: 3000, // 3 seconds in this example
                                                                                  }
                                                                                )
                                                                              } else {
                                                                                setSelectedOption(
                                                                                  "0"
                                                                                )
                                                                                setError(
                                                                                  false
                                                                                )
                                                                              }
                                                                            }}
                                                                            // disabled={}
                                                                          />{" "}
                                                                          No
                                                                        </label>
                                                                      </div>
                                                                      {/* Error message if checkbox is not selected */}
                                                                      {error && (
                                                                        <p className="text-danger text-center">
                                                                          Please
                                                                          select
                                                                          Yes or
                                                                          No
                                                                        </p>
                                                                      )}
                                                                      {(selectedOption ==
                                                                        "1" ||
                                                                        selectedOption ==
                                                                          "0") && (
                                                                        <div className="student-answers mt-3">
                                                                          <h5>
                                                                            Student
                                                                            Answers:
                                                                          </h5>
                                                                          {quspart.english_question_part_answer_type ===
                                                                            8 ||
                                                                          quspart.english_question_part_answer_type ===
                                                                            1 ||
                                                                          quspart.english_question_part_answer_type ===
                                                                            7 ? (
                                                                            <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                              {quspart.english_question_answers &&
                                                                                quspart.english_question_answers.map(
                                                                                  (
                                                                                    qusAns,
                                                                                    index1
                                                                                  ) => {
                                                                                    const stuAnswersarray =
                                                                                      quspart.StudentAnsAttempts.filter(
                                                                                        stuAns => {
                                                                                          const attemptStatus =
                                                                                            parseInt(
                                                                                              stuAns.attempt_status
                                                                                            )
                                                                                          return selectedOption ===
                                                                                            "1"
                                                                                            ? attemptStatus ===
                                                                                                0
                                                                                            : attemptStatus ===
                                                                                                1
                                                                                        }
                                                                                      ).flatMap(
                                                                                        stuAns => {
                                                                                          try {
                                                                                            const parsedAnswers =
                                                                                              JSON.parse(
                                                                                                stuAns.student_answer
                                                                                              )
                                                                                            return parsedAnswers.map(
                                                                                              ans => ({
                                                                                                ...ans,
                                                                                                pk_attempt_id:
                                                                                                  stuAns.pk_attempt_id,
                                                                                              })
                                                                                            )
                                                                                          } catch (error) {
                                                                                            console.error(
                                                                                              "Error parsing JSON:",
                                                                                              error
                                                                                            )
                                                                                            return null // or handle the error in an appropriate way
                                                                                          }
                                                                                        }
                                                                                      ) ||
                                                                                      []
                                                                                    const flattenedStuAnswers =
                                                                                      [].concat(
                                                                                        ...stuAnswersarray
                                                                                      )

                                                                                    if (
                                                                                      qusAns.english_answer_is_correct ===
                                                                                      1
                                                                                    ) {
                                                                                      let filteredAllStuAns =
                                                                                        flattenedStuAnswers.filter(
                                                                                          stuAns =>
                                                                                            parseInt(
                                                                                              stuAns.part_id
                                                                                            ) ===
                                                                                              parseInt(
                                                                                                qusAns.english_answer_part_id
                                                                                              ) &&
                                                                                            parseInt(
                                                                                              stuAns.answer_id
                                                                                            ) ===
                                                                                              parseInt(
                                                                                                qusAns.english_answer_id
                                                                                              )
                                                                                        ) ||
                                                                                        []

                                                                                      return (
                                                                                        <div
                                                                                          key={
                                                                                            index1
                                                                                          }
                                                                                          className="student-answers mt-3"
                                                                                        >
                                                                                          <ul className="list-group">
                                                                                            {filteredAllStuAns
                                                                                              .reverse()
                                                                                              .map(
                                                                                                (
                                                                                                  item,
                                                                                                  idx
                                                                                                ) => (
                                                                                                  <>
                                                                                                    <li
                                                                                                      className="list-group-item align-items-center gap-1 ps-2 mb-2"
                                                                                                      key={`${idx}_answer${item.pk_attempt_id}`}
                                                                                                      onClick={() => {
                                                                                                        setSelectedStudentAnswer(
                                                                                                          item.answer_id
                                                                                                        )
                                                                                                        setSelectedAttemptId(
                                                                                                          item.pk_attempt_id
                                                                                                        )
                                                                                                        setansError(
                                                                                                          false
                                                                                                        )
                                                                                                        console.log(
                                                                                                          item
                                                                                                        )
                                                                                                      }}
                                                                                                      style={{
                                                                                                        cursor:
                                                                                                          "pointer",
                                                                                                      }}
                                                                                                    >
                                                                                                      <div className="d-flex align-items-center gap-1">
                                                                                                        <input
                                                                                                          type="radio"
                                                                                                          name={`selected_answer_${idx}${item.pk_attempt_id}`}
                                                                                                          value={
                                                                                                            item.answer_id
                                                                                                          }
                                                                                                          checked={
                                                                                                            selectedAttemptId ===
                                                                                                            item.pk_attempt_id
                                                                                                          }
                                                                                                          onClick={() => {
                                                                                                            setSelectedStudentAnswer(
                                                                                                              item.answer_id
                                                                                                            )
                                                                                                            setSelectedAttemptId(
                                                                                                              item.pk_attempt_id
                                                                                                            )
                                                                                                            setansError(
                                                                                                              false
                                                                                                            )
                                                                                                          }}
                                                                                                        />
                                                                                                        {
                                                                                                          item.text
                                                                                                        }
                                                                                                      </div>
                                                                                                    </li>
                                                                                                  </>
                                                                                                )
                                                                                              )}
                                                                                          </ul>
                                                                                        </div>
                                                                                      )
                                                                                    }
                                                                                  }
                                                                                )}
                                                                            </ul>
                                                                          ) : quspart.english_question_part_answer_type ===
                                                                            4 ? (
                                                                            //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                                            <ul className="list-group">
                                                                              {quspart
                                                                                .StudentAnsAttempts
                                                                                .length >
                                                                              0 ? (
                                                                                quspart.StudentAnsAttempts.filter(
                                                                                  stuAns => {
                                                                                    const attemptStatus =
                                                                                      parseInt(
                                                                                        stuAns.attempt_status
                                                                                      )
                                                                                    return selectedOption ===
                                                                                      "1"
                                                                                      ? attemptStatus ===
                                                                                          0
                                                                                      : attemptStatus ===
                                                                                          1
                                                                                  }
                                                                                ).map(
                                                                                  (
                                                                                    stuAns,
                                                                                    index
                                                                                  ) => {
                                                                                    const studentAnswer =
                                                                                      JSON.parse(
                                                                                        stuAns.student_answer
                                                                                      )
                                                                                    const flatStuAnswers =
                                                                                      [].concat(
                                                                                        ...studentAnswer
                                                                                      )

                                                                                    const filterStuAns =
                                                                                      flatStuAnswers.filter(
                                                                                        stuAns =>
                                                                                          quspart?.english_question_answers?.some(
                                                                                            answer =>
                                                                                              parseInt(
                                                                                                stuAns.part_id
                                                                                              ) ===
                                                                                                parseInt(
                                                                                                  answer.english_answer_part_id
                                                                                                ) &&
                                                                                              parseInt(
                                                                                                stuAns.answer_id
                                                                                              ) ===
                                                                                                parseInt(
                                                                                                  answer.english_answer_id
                                                                                                )
                                                                                          )
                                                                                      ) ||
                                                                                      []

                                                                                    return filterStuAns.length >
                                                                                      0
                                                                                      ? filterStuAns.map(
                                                                                          (
                                                                                            filteredAns,
                                                                                            filteredIndex
                                                                                          ) => {
                                                                                            return (
                                                                                              <>
                                                                                                <li
                                                                                                  className="list-group-item"
                                                                                                  key={`${index}_${filteredIndex}`}
                                                                                                >
                                                                                                  <div
                                                                                                    className="d-flex align-items-center gap-1"
                                                                                                    onClick={() => {
                                                                                                      setSelectedStudentAnswer(
                                                                                                        filteredAns.answer_id
                                                                                                      )
                                                                                                      setSelectedAttemptId(
                                                                                                        stuAns.pk_attempt_id
                                                                                                      )
                                                                                                      setansError(
                                                                                                        false
                                                                                                      )
                                                                                                    }}
                                                                                                    style={{
                                                                                                      cursor:
                                                                                                        "pointer",
                                                                                                    }}
                                                                                                  >
                                                                                                    {/* Allow user to select the answer */}
                                                                                                    <input
                                                                                                      type="radio"
                                                                                                      name={`selected_answer_${index}`}
                                                                                                      value={
                                                                                                        filteredAns.answer_id
                                                                                                      }
                                                                                                      checked={
                                                                                                        selectedStudentAnswer ===
                                                                                                        filteredAns.answer_id
                                                                                                      }
                                                                                                      onChange={() => {
                                                                                                        setSelectedStudentAnswer(
                                                                                                          filteredAns.answer_id
                                                                                                        )
                                                                                                        setSelectedAttemptId(
                                                                                                          stuAns.pk_attempt_id
                                                                                                        )
                                                                                                        setansError(
                                                                                                          false
                                                                                                        )
                                                                                                      }}
                                                                                                    />
                                                                                                    <div
                                                                                                      dangerouslySetInnerHTML={{
                                                                                                        __html:
                                                                                                          filteredAns.text ||
                                                                                                          "No answer provided",
                                                                                                      }}
                                                                                                    ></div>
                                                                                                  </div>
                                                                                                </li>
                                                                                              </>
                                                                                            )
                                                                                          }
                                                                                        )
                                                                                      : null
                                                                                  }
                                                                                )
                                                                              ) : (
                                                                                <li className="list-group-item">
                                                                                  No
                                                                                  student
                                                                                  answers
                                                                                  available
                                                                                </li>
                                                                              )}
                                                                            </ul>
                                                                          ) : (
                                                                            <p className="text-center">
                                                                              No
                                                                              option
                                                                            </p>
                                                                          )}
                                                                          {anserror && (
                                                                            <p className="text-danger text-center">
                                                                              Please
                                                                              select
                                                                              the
                                                                              correct
                                                                              answer
                                                                            </p>
                                                                          )}
                                                                        </div>
                                                                      )}
                                                                      {/* Feedback Textarea */}
                                                                      <textarea
                                                                        className="form-control my-2"
                                                                        placeholder="Enter feedback..."
                                                                        value={
                                                                          feedback
                                                                        }
                                                                        onChange={e =>
                                                                          setFeedback(
                                                                            e
                                                                              .target
                                                                              .value
                                                                          )
                                                                        }
                                                                      ></textarea>

                                                                      {/* Buttons */}
                                                                      <div className="d-flex justify-content-between mt-3">
                                                                        <button
                                                                          className="btn btn-secondary btn-sm"
                                                                          onClick={() =>
                                                                            setActivePopoverId(
                                                                              null
                                                                            )
                                                                          }
                                                                        >
                                                                          Cancel
                                                                        </button>
                                                                        <button
                                                                          className="btn btn-primary btn-sm"
                                                                          onClick={
                                                                            handleSubmit
                                                                          }
                                                                        >
                                                                          Submit
                                                                        </button>
                                                                      </div>
                                                                    </PopoverBody>
                                                                  </UncontrolledPopover>
                                                                )}
                                                              </div>
                                                            )
                                                          ) : null}
                                                        </div>
                                                        {/* Anse category statement Star */}
                                                        {quspart.english_question_part_answer_type ===
                                                          8 ||
                                                        quspart.english_question_part_answer_type ===
                                                          1 ||
                                                        quspart.english_question_part_answer_type ===
                                                          7 ? (
                                                          <ul className="dg-selector width-controll list-unstyled mb-0">
                                                            {" "}
                                                            {parseInt(
                                                              quspart.english_question_part_automark
                                                            ) === 1 ? (
                                                              ""
                                                            ) : (
                                                              <div className="d-flex justify-content-end">
                                                                <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                  Manual Marking
                                                                </span>
                                                              </div>
                                                            )}
                                                            {quspart.english_question_answers &&
                                                              quspart.english_question_answers.map(
                                                                (
                                                                  qusAns,
                                                                  index1
                                                                ) => {
                                                                  // Your logic for filtering student answers and determining status_color and border_color
                                                                  const stuAnswersarray =
                                                                    quspart.StudentAnsAttempts.map(
                                                                      stuAns => {
                                                                        try {
                                                                          return JSON.parse(
                                                                            stuAns.student_answer
                                                                          )
                                                                        } catch (error) {
                                                                          console.error(
                                                                            "Error parsing JSON:",
                                                                            error
                                                                          )
                                                                          return null // or handle the error in an appropriate way
                                                                        }
                                                                      }
                                                                    ) || [] // Extracting session keys
                                                                  //console.log(stuAnswersarray);
                                                                  // Assuming stuAnswersarray is a nested array
                                                                  const flattenedStuAnswers =
                                                                    [].concat(
                                                                      ...stuAnswersarray
                                                                    )
                                                                  let cleanedText =
                                                                    qusAns.english_answer_text
                                                                      .replace(
                                                                        /&nbsp;/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /`/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /<[^>]*>/g,
                                                                        ""
                                                                      ) || ""
                                                                  let resultTest =
                                                                    cleanedText
                                                                      .toLowerCase()
                                                                      .trim()
                                                                  let answers =
                                                                    resultTest.split(
                                                                      "|"
                                                                    ) || []
                                                                  let firstAnswer =
                                                                    answers[0]
                                                                      ? answers[0].trim()
                                                                      : "No_Data"
                                                                  let secondAnswer =
                                                                    answers[1]
                                                                      ? answers[1].trim()
                                                                      : "No_Data"
                                                                  let answersArray =
                                                                    cleanedText
                                                                      .split(
                                                                        "|"
                                                                      )
                                                                      .map(
                                                                        ans =>
                                                                          ans
                                                                            .trim()
                                                                            .toLowerCase()
                                                                      )
                                                                      .filter(
                                                                        Boolean
                                                                      ) || []

                                                                  if (
                                                                    qusAns.english_answer_is_correct ===
                                                                    1
                                                                  ) {
                                                                    let filteredStuAns =
                                                                      flattenedStuAnswers.filter(
                                                                        stuAns =>
                                                                          parseInt(
                                                                            stuAns.part_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_part_id
                                                                            ) &&
                                                                          (stuAns.text
                                                                            .toLowerCase()
                                                                            .trim() ==
                                                                            resultTest ||
                                                                            stuAns.text
                                                                              .toLowerCase()
                                                                              .trim() ==
                                                                              firstAnswer ||
                                                                            stuAns.text
                                                                              .toLowerCase()
                                                                              .trim() ==
                                                                              secondAnswer ||
                                                                            answersArray.some(
                                                                              answer =>
                                                                                answer ==
                                                                                stuAns.text
                                                                                  .toLowerCase()
                                                                                  .trim()
                                                                            )) &&
                                                                          parseInt(
                                                                            stuAns.answer_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_id
                                                                            )
                                                                      ) || []

                                                                    let filteredAllStuAns =
                                                                      flattenedStuAnswers.filter(
                                                                        stuAns =>
                                                                          parseInt(
                                                                            stuAns.part_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_part_id
                                                                            ) &&
                                                                          parseInt(
                                                                            stuAns.answer_id
                                                                          ) ===
                                                                            parseInt(
                                                                              qusAns.english_answer_id
                                                                            )
                                                                      ) || []

                                                                    return (
                                                                      <li
                                                                        key={
                                                                          index1
                                                                        }
                                                                        className={
                                                                          parseInt(
                                                                            quspart.english_question_part_automark
                                                                          ) ===
                                                                          1
                                                                            ? filteredStuAns.length >
                                                                              0
                                                                              ? "input_box small_input_box"
                                                                              : "input_box small_input_box"
                                                                            : " input_box small_input_box"
                                                                        }
                                                                      >
                                                                        <input
                                                                          id={
                                                                            index1 +
                                                                            Math.floor(
                                                                              Math.random() *
                                                                                5
                                                                            )
                                                                          }
                                                                          type="text"
                                                                          className={
                                                                            parseInt(
                                                                              quspart.english_question_part_automark
                                                                            ) ===
                                                                            1
                                                                              ? (filteredStuAns.length >
                                                                                  0 &&
                                                                                  !quspart?.markedReport >
                                                                                    0) ||
                                                                                (quspart?.markedReport >
                                                                                  0 &&
                                                                                  quspart.StudentAnsAttempts.some(
                                                                                    attempt =>
                                                                                      parseInt(
                                                                                        attempt.attempt_status
                                                                                      ) ==
                                                                                      1
                                                                                  ))
                                                                                ? "answersuccess"
                                                                                : "answererror "
                                                                              : quspart
                                                                                  .StudentAnsAttempts
                                                                                  .length >
                                                                                  0 &&
                                                                                quspart.english_question_part_automark ==
                                                                                  0 &&
                                                                                ActivityData1.marked_for_manual_marking ==
                                                                                  1
                                                                              ? quspart
                                                                                  .StudentAnsAttempts[0]
                                                                                  .attempt_status ==
                                                                                1
                                                                                ? "answersuccess"
                                                                                : "answererror"
                                                                              : "answereditor"
                                                                          }
                                                                          value={
                                                                            filteredAllStuAns
                                                                              .filter(
                                                                                item =>
                                                                                  parseInt(
                                                                                    item.answer_id
                                                                                  ) ===
                                                                                  parseInt(
                                                                                    qusAns.english_answer_id
                                                                                  )
                                                                              )
                                                                              .reverse()
                                                                              .map(
                                                                                item =>
                                                                                  item.text
                                                                              )
                                                                              .find(
                                                                                text =>
                                                                                  text !==
                                                                                  undefined
                                                                              ) ||
                                                                            "" // Find the first non-undefined text value
                                                                          }
                                                                          disabled={
                                                                            true
                                                                          }
                                                                          //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                          onChange={e =>
                                                                            handletext(
                                                                              e,
                                                                              qusAns.english_answer_id,
                                                                              qusAns.english_answer_part_id
                                                                            )
                                                                          }
                                                                          // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                        />
                                                                      </li>
                                                                    )
                                                                  }
                                                                }
                                                              )}
                                                          </ul>
                                                        ) : quspart.english_question_part_answer_type ===
                                                          4 ? (
                                                          //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                          <ul className="dg-selector choose-it-question width-controll list-unstyled mb-0">
                                                            {parseInt(
                                                              quspart.english_question_part_automark
                                                            ) === 1 ? (
                                                              ""
                                                            ) : (
                                                              <div className="d-flex justify-content-end">
                                                                <span className="badge bg-primary font-size-14 mt-auto mb-2">
                                                                  Manual Marking
                                                                </span>
                                                              </div>
                                                            )}
                                                            {quspart.english_question_answers &&
                                                              rearrangeEvenOdd(
                                                                quspart.english_question_answers
                                                              ).map(
                                                                (
                                                                  qusAns,
                                                                  index1
                                                                ) => {
                                                                  const cleanText =
                                                                    qusAns.english_answer_text
                                                                      .replace(
                                                                        /&nbsp;/g,
                                                                        ""
                                                                      )

                                                                      .replace(
                                                                        /`/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /<[^>]*>/g,
                                                                        ""
                                                                      )
                                                                      .trim()

                                                                  const hasImage =
                                                                    /<img\s+[^>]*>/gi.test(
                                                                      qusAns.english_answer_text
                                                                    )

                                                                  if (
                                                                    !cleanText &&
                                                                    !hasImage
                                                                  ) {
                                                                    return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                  }

                                                                  serialNumber++

                                                                  let filteredStuAns =
                                                                    flattenedStuAnswers.filter(
                                                                      stuAns =>
                                                                        parseInt(
                                                                          stuAns.part_id
                                                                        ) ===
                                                                          parseInt(
                                                                            qusAns.english_answer_part_id
                                                                          ) &&
                                                                        parseInt(
                                                                          stuAns.answer_id
                                                                        ) ===
                                                                          parseInt(
                                                                            qusAns.english_answer_id
                                                                          )
                                                                    ) || []

                                                                  //OverRide check status start
                                                                  let filteredStuAnsoverridedata =
                                                                    quspart.StudentAnsAttempts.filter(
                                                                      stuAns =>
                                                                        parseInt(
                                                                          stuAns.attempt_status
                                                                        ) === 1
                                                                    ) || []
                                                                  const stuAnswersoverridearray =
                                                                    filteredStuAnsoverridedata.map(
                                                                      stuAns => {
                                                                        try {
                                                                          return JSON.parse(
                                                                            stuAns.student_answer
                                                                          )
                                                                        } catch (error) {
                                                                          console.error(
                                                                            "Error parsing JSON:",
                                                                            error
                                                                          )
                                                                          return null // or handle the error in an appropriate way
                                                                        }
                                                                      }
                                                                    ) || []
                                                                  const flattenedoverrideStuAnswers =
                                                                    [].concat(
                                                                      ...stuAnswersoverridearray
                                                                    )

                                                                  let filteredStuAnsoverride =
                                                                    flattenedoverrideStuAnswers.filter(
                                                                      stuAns =>
                                                                        parseInt(
                                                                          stuAns.part_id
                                                                        ) ===
                                                                          parseInt(
                                                                            qusAns.english_answer_part_id
                                                                          ) &&
                                                                        parseInt(
                                                                          stuAns.answer_id
                                                                        ) ===
                                                                          parseInt(
                                                                            qusAns.english_answer_id
                                                                          )
                                                                    ) || []

                                                                  //OverRide check status end

                                                                  var status_color =
                                                                    "selector-general cursor-pointer"
                                                                  var border_color =
                                                                    "border-start-secondary"
                                                                  if (
                                                                    filteredStuAns.length >
                                                                      0 &&
                                                                    parseInt(
                                                                      quspart.english_question_part_automark
                                                                    ) === 1
                                                                  ) {
                                                                    if (
                                                                      parseInt(
                                                                        qusAns.english_answer_is_correct
                                                                      ) === 1 &&
                                                                      !quspart?.markedReport >
                                                                        0
                                                                    ) {
                                                                      status_color =
                                                                        "selector-success"
                                                                      border_color =
                                                                        "border-start-success"
                                                                    } else if (
                                                                      filteredStuAnsoverride.length >
                                                                        0 &&
                                                                      quspart.markedReport >
                                                                        0
                                                                    ) {
                                                                      status_color =
                                                                        "selector-success"
                                                                      border_color =
                                                                        "border-start-success"
                                                                    } else {
                                                                      status_color =
                                                                        "selector-wrong "
                                                                      border_color =
                                                                        "border-start-danger"
                                                                    }
                                                                  } else if (
                                                                    quspart
                                                                      .StudentAnsAttempts
                                                                      .length >
                                                                      0 &&
                                                                    quspart.english_question_part_automark ==
                                                                      0 &&
                                                                    ActivityData1.marked_for_manual_marking ==
                                                                      1
                                                                  ) {
                                                                    if (
                                                                      quspart
                                                                        .StudentAnsAttempts[0]
                                                                        .attempt_status ==
                                                                      1
                                                                    ) {
                                                                      status_color =
                                                                        "selector-success"
                                                                      border_color =
                                                                        "border-start-success"
                                                                    } else {
                                                                      status_color =
                                                                        "selector-wrong "
                                                                      border_color =
                                                                        "border-start-danger"
                                                                    }
                                                                  }
                                                                  //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                  return (
                                                                    <li
                                                                      className={
                                                                        status_color +
                                                                        " choose e_choose"
                                                                      }
                                                                      key={
                                                                        index1
                                                                      }
                                                                    >
                                                                      <div
                                                                        style={{
                                                                          position: "absolute",
                                                                          left: "-40px",
                                                                          top: "50%",
                                                                          transform: "translateY(-50%)",
                                                                        }}
                                                                        onClick={e => e.stopPropagation()}
                                                                      >
                                                                        {renderSpeakerToggle(
                                                                          "ans-" + qusAns.english_answer_id,
                                                                          [qusAns.english_answer_text]
                                                                        )}
                                                                      </div>
                                                                      <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                                                        <span className="dg-serial-badge">{serialNumber}</span>
                                                                      </div>
                                                                      <div
                                                                        className={
                                                                          "p-2 dg-media " +
                                                                          {
                                                                            border_color,
                                                                          }
                                                                        }
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            qusAns.english_answer_text
                                                                              ? qusAns.english_answer_text
                                                                              : null,
                                                                        }}
                                                                      ></div>
                                                                    </li>
                                                                  )
                                                                }
                                                              )}
                                                          </ul>
                                                        ) : (
                                                          <p className="text-center">
                                                            No option
                                                          </p>
                                                        )}
                                                        {/* Anse category statement end */}
                                                      </div>
                                                    )
                                                  } else {
                                                    return quspart.english_question_part_text ? (
                                                      <div
                                                        key={index}
                                                        className="mt-3"
                                                      >
                                                        <div className="d-flex gap-2 flex-row ">
                                                          {/* <div className="mr-3">{index + 1}</div> */}
                                                          <div
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                quspart.english_question_part_text
                                                                  ? quspart.english_question_part_text
                                                                      .replace(
                                                                        /\[\[(.+?)\]\]/g,
                                                                        function (
                                                                          match,
                                                                          p1
                                                                        ) {
                                                                          return p1.length >
                                                                            1
                                                                            ? `<span class="text-bg-yellow">${p1}</span>`
                                                                            : `<span class="text-bg-blue">${p1}</span>`
                                                                        }
                                                                      )
                                                                      .replace(
                                                                        /\{\{/g,
                                                                        "<u>"
                                                                      )
                                                                      .replace(
                                                                        /\}\}/g,
                                                                        "</u>"
                                                                      )
                                                                      .replace(
                                                                        /\[(\d+)Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /\[Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                  : null,
                                                            }}
                                                          ></div>
                                                        </div>
                                                      </div>
                                                    ) : null
                                                  }
                                                }
                                              )}

                                            {/* past question End */}

                                            <>
                                              <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                Solution
                                              </h4>
                                              <div
                                                className="e_feedBack gap-5 d-flex"
                                                style={{
                                                  border: "1px solid #1a1a1a",
                                                  borderRadius: "4px",
                                                  fontSize: "16px",
                                                }}
                                              >
                                                <div>
                                                  {InnerActivityData.english_question_parts &&
                                                    InnerActivityData.english_question_parts.map(
                                                      (quspart, index) => {
                                                        if (
                                                          quspart.english_question_answers &&
                                                          quspart
                                                            .english_question_answers
                                                            .length > 0 &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text !=
                                                            ""
                                                        ) {
                                                          return (
                                                            <div
                                                              className="d-flex gap-2 flex-row"
                                                              key={index}
                                                            >
                                                              {/* <div className="mr-3">{index + 1}</div> */}
                                                              {quspart
                                                                .StudentQusSkip
                                                                ?.length ===
                                                                0 &&
                                                                quspart.english_question_answers
                                                                  .filter(
                                                                    CorrAns =>
                                                                      parseInt(
                                                                        CorrAns.english_answer_is_correct
                                                                      ) === 1
                                                                  )
                                                                  .map(
                                                                    (
                                                                      qusAns,
                                                                      index1
                                                                    ) => (
                                                                      <div
                                                                        key={
                                                                          index1
                                                                        }
                                                                        dangerouslySetInnerHTML={{
                                                                          __html:
                                                                            qusAns.english_answer_text
                                                                              ? qusAns.english_answer_text
                                                                              : null,
                                                                        }}
                                                                      ></div>
                                                                    )
                                                                  )}
                                                            </div>
                                                          )
                                                        }
                                                      }
                                                    )}
                                                </div>
                                                <div>
                                                  {InnerActivityData.english_question_parts &&
                                                    InnerActivityData.english_question_parts.map(
                                                      (quspart, index) => {
                                                        if (
                                                          quspart.english_question_answers &&
                                                          quspart
                                                            .english_question_answers
                                                            .length > 0 &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text &&
                                                          quspart
                                                            .english_question_answers[0]
                                                            .english_answer_text !=
                                                            ""
                                                        ) {
                                                          return (
                                                            <div
                                                              className="d-flex gap-2 flex-row"
                                                              key={index}
                                                            >
                                                              {/* <div className="mr-3">{index + 1}</div> */}
                                                              {quspart.english_question_answers
                                                                .filter(
                                                                  CorrAns =>
                                                                    parseInt(
                                                                      CorrAns.english_answer_is_correct
                                                                    ) === 1
                                                                )
                                                                .map(
                                                                  (
                                                                    qusAns,
                                                                    index1
                                                                  ) => (
                                                                    <div
                                                                      key={
                                                                        index1
                                                                      }
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          qusAns.english_answer_feedback
                                                                            ? qusAns.english_answer_feedback
                                                                            : "&nbsp;",
                                                                      }}
                                                                    ></div>
                                                                  )
                                                                )}
                                                            </div>
                                                          )
                                                        }
                                                      }
                                                    )}
                                                </div>
                                              </div>
                                            </>
                                          </li>
                                        </ul>

                                        <div className={'action-btns d-flex gap-4 mt-2' + (activeindex + 1 > 1 ? ' justify-content-between' : ' justify-content-end')}>
                                          {/* Render a "Prev" button if the active index is greater than 0 */}
                                          {activeindex + 1 > 1 ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(activeindex)
                                              }}
                                            >
                                              Prev
                                            </Button>
                                          ) : null}

                                          {/* Render a "Next" button if the active index is less than the total length of LessonActivitiesQuestions array */}
                                          {activeindex + 1 <
                                          ActivityData.LessonActivitiesQuestions
                                            .length ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(
                                                  activeindex + 1 + 1
                                                )
                                              }}
                                            >
                                              Next
                                            </Button>
                                          ) : null}
                                        </div>
                                      </div>
                                    </TabPane>
                                  )
                                } else {
                                  return (
                                    <p className="text-center">No question</p>
                                  )
                                }
                              }
                            }
                          )
                        } else if (
                          ActivityData1 &&
                          ActivityData1.fk_sub_id &&
                          parseInt(ActivityData1.fk_sub_id) === 2
                        ) {
                          return ActivityData1.question.map(
                            (InnerActivityData, index) => {
                              if (index === 0) {
                                if (
                                  InnerActivityData &&
                                  InnerActivityData.question_parts &&
                                  InnerActivityData.question_parts.length > 0
                                ) {
                                  return (
                                    <TabPane
                                      tabId={activeindex + 1}
                                      key={activeindex + 1}
                                      className={
                                        parseInt(customActiveTab) ===
                                        activeindex + 1
                                          ? "active"
                                          : ""
                                      }
                                    >
                                      <div
                                        style={getOverlayCardStyle()}
                                        className={`hw-list mt-4 pb-3  ${
                                          localStorage.getItem("is_fontsize") ==
                                          1
                                            ? "stu-custom-font-size"
                                            : ""
                                        }`}
                                      >
                                        <ul className="list-unstyled mb-0 question_container">
                                          <li className="justify-content-between">
                                            <div className="d-flex align-items-start gap-4 justify-content-end nv-sticky-header">
                                              {/* <p className="mb-0 text-uppercase font-size-16">
                                  {InnerActivityData.question_new_topic && InnerActivityData.question_new_topic.level_name ? 
                                  InnerActivityData.question_new_topic.level_name +' /' : null}
                                  
                                  {InnerActivityData.question_new_topic && InnerActivityData.question_new_topic.topic_name ? 
                                  InnerActivityData.question_new_topic.topic_name +' /' : null}
          
                                  {InnerActivityData.question_new_topic && InnerActivityData.question_new_topic.sub_topics_name ? 
                                  InnerActivityData.question_new_topic.sub_topics_name +' /' : null}
          
                                </p> */}
                                              <div className="mb-0 d-flex align-items-center gap-2">
                                                <p className="mb-0">
                                                  #
                                                  {InnerActivityData.question_id
                                                    ? InnerActivityData.question_id
                                                    : null}
                                                </p>
                                                <span
                                                  onClick={() =>
                                                    tog_standard(ActivityData1)
                                                  }
                                                >
                                                  <i className="mdi mdi-flag-variant-outline font-size-18"></i>
                                                </span>

                                                <span
                                                  className="p-1"
                                                  id={`Popover_${
                                                    activeindex + 1
                                                  }`}
                                                  type="button"
                                                >
                                                  <i class="fa fa-info font-size-16"></i>
                                                </span>
                                                {/* Popover */}
                                               <UncontrolledPopover
                                                  placement="bottom"
                                                  trigger="legacy"
                                                  target={`Popover_${
                                                    activeindex + 1
                                                  }`} // Matches button ID
                                                  boundariesElement="viewport"
                                                  modifiers={[
                                                    { name: "preventOverflow", options: { boundary: "viewport", padding: 8 } },
                                                    { name: "flip", options: { fallbackPlacements: ["top", "right", "left"] } },
                                                  ]}
                                                >
                                                  <PopoverBody
                                                    className="shadow rounded bg-white p-3 math-guide-popover"
                                                    style={{
                                                      width: "min(600px, 92vw)",
                                                      maxHeight: "90vh",
                                                      overflowY: "auto",
                                                    }}
                                                  >
                                                    <h5 className="text-center">
                                                      <strong>
                                                        User Guide for Math
                                                        Answers
                                                      </strong>
                                                    </h5>

                                                    {/* Accordion */}
                                                    <Accordion
                                                      open={openAccordion}
                                                      toggle={toggleAccordion}
                                                    >
                                                      <AccordionItem>
                                                        <AccordionHeader targetId="1">
                                                          <strong>
                                                            Numbers
                                                          </strong>
                                                        </AccordionHeader>
                                                        <AccordionBody
                                                          accordionId="1"
                                                          className="p-0 answerQuide"
                                                        >
                                                          {/* Table inside Accordion */}
                                                          <Table
                                                            bordered
                                                            size="sm"
                                                            className="mb-0 text-start"
                                                          >
                                                            <thead>
                                                              <tr className="align-middle fw-bold">
                                                                <th>
                                                                  Math
                                                                  Expression
                                                                </th>
                                                                <th>
                                                                  How to Type
                                                                </th>
                                                                <th>
                                                                  Not Accepted
                                                                </th>
                                                                <th>
                                                                  Similar
                                                                  Expressions
                                                                </th>
                                                                <th>Tips</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Whole number
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 1.5<br></br>
                                                                  • 1,5<br></br>
                                                                  • 1/5<br></br>
                                                                  • 1\5<br></br>
                                                                  • 015
                                                                </td>
                                                                <td>
                                                                  • 234<br></br>
                                                                  • 4078
                                                                  <br></br>•
                                                                  37580<br></br>
                                                                  • 194026
                                                                  <br></br>•
                                                                  -763<br></br>
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  negative sign
                                                                  “-” for
                                                                  negative
                                                                  numbers.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Decimal e.g.{" "}
                                                                  <span className="text-danger">
                                                                    0.67
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    0.67
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 067<br></br>
                                                                  • 0,67
                                                                  <br></br>•
                                                                  0:67<br></br>•
                                                                  0_67
                                                                </td>
                                                                <td>
                                                                  • 0.2<br></br>
                                                                  • 1.45
                                                                  <br></br>•
                                                                  0.768<br></br>
                                                                  • 30.85
                                                                  <br></br>•
                                                                  -4.10<br></br>
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a dot
                                                                  “.” for
                                                                  decimals.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Multiple
                                                                  answers e.g.{" "}
                                                                  <span className="text-danger">
                                                                    1, 2, 4
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    1, 2, 4
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 124<br></br>
                                                                  • 1.2.4
                                                                  <br></br>•
                                                                  1_2_4<br></br>
                                                                  • 1&2&4
                                                                </td>
                                                                <td>
                                                                  • 3, 6
                                                                  <br></br>• 5,
                                                                  10, 15, 20
                                                                  <br></br>• -3,
                                                                  -2, -1
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  comma,
                                                                  followed by a
                                                                  space for each
                                                                  answer.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Ratio e.g.{" "}
                                                                  <span className="text-danger">
                                                                    2:3
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    2:3
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 23<br></br>•
                                                                  2.3<br></br>•
                                                                  2,3<br></br>•
                                                                  2_3
                                                                </td>
                                                                <td>
                                                                  • 3:2<br></br>
                                                                  • 7:10
                                                                  <br></br>•
                                                                  12:5<br></br>•
                                                                  1:4:9<br></br>
                                                                  • 6:3:8
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  colon “:” for
                                                                  ratios.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Indices e.g.{" "}
                                                                  <span className="text-danger">
                                                                    2^3
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    2^3
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 23<br></br>•
                                                                  2.3<br></br>•
                                                                  2,3<br></br>•
                                                                  2_3
                                                                </td>
                                                                <td>
                                                                  • 3^4<br></br>
                                                                  • 10^2
                                                                  <br></br>•
                                                                  -5^3<br></br>•
                                                                  8^(-5)
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include “^”
                                                                  for indices.
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </Table>
                                                        </AccordionBody>
                                                      </AccordionItem>
                                                      <AccordionItem>
                                                        <AccordionHeader targetId="2">
                                                          <strong>
                                                            Fractions
                                                          </strong>
                                                        </AccordionHeader>
                                                        <AccordionBody
                                                          accordionId="2"
                                                          className="p-0 answerQuide"
                                                        >
                                                          {/* Table inside Accordion */}
                                                          <Table
                                                            bordered
                                                            size="sm"
                                                            className="mb-0 text-start"
                                                          >
                                                            <thead>
                                                              <tr className="align-middle fw-bold">
                                                                <th>
                                                                  Math
                                                                  Expression
                                                                </th>
                                                                <th>
                                                                  How to Type
                                                                </th>
                                                                <th>
                                                                  Not Accepted
                                                                </th>
                                                                <th>
                                                                  Similar
                                                                  Expressions
                                                                </th>
                                                                <th>Tips</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Proper
                                                                  fraction e.g.{" "}
                                                                  <span className="text-danger">
                                                                    3/5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    3/5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 35<br></br>•
                                                                  3 5 (with a
                                                                  space)
                                                                  <br></br>• 3.5
                                                                  <br></br>• 3,5
                                                                  <br></br>• 3_5
                                                                  <br></br>• 3\5
                                                                </td>
                                                                <td>
                                                                  • 1/2<br></br>
                                                                  • 4/7<br></br>
                                                                  • -5/8
                                                                  <br></br>•
                                                                  10/11<br></br>
                                                                  • -7/12
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  slash “/” for
                                                                  fractions.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Improper
                                                                  fraction e.g.{" "}
                                                                  <span className="text-danger">
                                                                    9/2
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    9/2
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 92<br></br>•
                                                                  9 2 (with a
                                                                  space)
                                                                  <br></br>• 9.2
                                                                  <br></br>• 9,2
                                                                  <br></br>• 9_2
                                                                  <br></br>• 9\2
                                                                </td>
                                                                <td>
                                                                  • 7/3<br></br>
                                                                  • 8/5<br></br>
                                                                  • -13/3
                                                                  <br></br>•
                                                                  14/11<br></br>
                                                                  • -23/10
                                                                </td>
                                                                <td>
                                                                  If the
                                                                  question does
                                                                  not specify
                                                                  the answer to
                                                                  be an improper
                                                                  fraction, its
                                                                  equivalent
                                                                  mixed number
                                                                  is accepted as
                                                                  well.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Mixed number
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    2 3/5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    2 3/5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 23/5
                                                                  (without a
                                                                  space)
                                                                  <br></br>•
                                                                  2.3/5<br></br>
                                                                  • 2,3/5
                                                                  <br></br>•
                                                                  2_3/5
                                                                </td>
                                                                <td>
                                                                  • 4 1/3
                                                                  <br></br>• 7
                                                                  5/8<br></br>•
                                                                  10 3/4
                                                                  <br></br>• -2
                                                                  2/7<br></br>•
                                                                  -10 4/11
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  space between
                                                                  the whole
                                                                  number and the
                                                                  proper
                                                                  fraction.
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </Table>
                                                        </AccordionBody>
                                                      </AccordionItem>
                                                      <AccordionItem>
                                                        <AccordionHeader targetId="3">
                                                          <strong>Time</strong>
                                                        </AccordionHeader>
                                                        <AccordionBody
                                                          accordionId="3"
                                                          className="p-0 answerQuide"
                                                        >
                                                          {/* Table inside Accordion */}
                                                          <Table
                                                            bordered
                                                            size="sm"
                                                            className="mb-0 text-start"
                                                          >
                                                            <thead>
                                                              <tr className="align-middle fw-bold">
                                                                <th>
                                                                  Math
                                                                  Expression
                                                                </th>
                                                                <th>
                                                                  How to Type
                                                                </th>
                                                                <th>
                                                                  Not Accepted
                                                                </th>
                                                                <th>
                                                                  Similar
                                                                  Expressions
                                                                </th>
                                                                <th>Tips</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  12-hour clock
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    4:15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    4:15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 415<br></br>
                                                                  • 4 15 (with a
                                                                  space)
                                                                  <br></br>•
                                                                  4.15<br></br>•
                                                                  04:15<br></br>
                                                                  • 4,15
                                                                </td>
                                                                <td>
                                                                  • 2:30
                                                                  <br></br>•
                                                                  5:45<br></br>•
                                                                  8:05<br></br>•
                                                                  10:22<br></br>
                                                                  • 12:03
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  colon “:” for
                                                                  times on the
                                                                  12-hour clock.
                                                                  <br></br>
                                                                  “am” or “pm”
                                                                  may be in the
                                                                  question; do
                                                                  not include
                                                                  the unit in
                                                                  the answer.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  24-hour time
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    16 15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    16 15
                                                                  </span>{" "}
                                                                  (with a space)
                                                                </td>
                                                                <td>
                                                                  • 1615
                                                                  <br></br>•
                                                                  16.15<br></br>
                                                                  • 16:15
                                                                  <br></br>•
                                                                  16,15
                                                                </td>
                                                                <td>
                                                                  • 02 30
                                                                  <br></br>• 17
                                                                  45<br></br>•
                                                                  20 05<br></br>
                                                                  • 20 22
                                                                  <br></br>• 00
                                                                  03
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  space between
                                                                  the hours and
                                                                  the minutes.
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </Table>
                                                        </AccordionBody>
                                                      </AccordionItem>
                                                      <AccordionItem>
                                                        <AccordionHeader targetId="4">
                                                          <strong>
                                                            Algebra
                                                          </strong>
                                                        </AccordionHeader>
                                                        <AccordionBody
                                                          accordionId="4"
                                                          className="p-0 answerQuide"
                                                        >
                                                          {/* Table inside Accordion */}
                                                          <Table
                                                            bordered
                                                            size="sm"
                                                            className="mb-0 text-start"
                                                          >
                                                            <thead>
                                                              <tr className="align-middle fw-bold">
                                                                <th>
                                                                  Math
                                                                  Expression
                                                                </th>
                                                                <th>
                                                                  How to Type
                                                                </th>
                                                                <th>
                                                                  Not Accepted
                                                                </th>
                                                                <th>
                                                                  Similar
                                                                  Expressions
                                                                </th>
                                                                <th>Tips</th>
                                                              </tr>
                                                            </thead>
                                                            <tbody>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  12-hour clock
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    4:15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    4:15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 415<br></br>
                                                                  • 4 15 (with a
                                                                  space)
                                                                  <br></br>•
                                                                  4.15<br></br>•
                                                                  04:15<br></br>
                                                                  • 4,15
                                                                </td>
                                                                <td>
                                                                  • 2:30
                                                                  <br></br>•
                                                                  5:45<br></br>•
                                                                  8:05<br></br>•
                                                                  10:22<br></br>
                                                                  • 12:03
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  colon “:” for
                                                                  times on the
                                                                  12-hour clock.
                                                                  <br></br>
                                                                  “am” or “pm”
                                                                  may be in the
                                                                  question; do
                                                                  not include
                                                                  the unit in
                                                                  the answer.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  24-hour time
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    16 15
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    16 15
                                                                  </span>{" "}
                                                                  (with a space)
                                                                </td>
                                                                <td>
                                                                  • 1615
                                                                  <br></br>•
                                                                  16.15<br></br>
                                                                  • 16:15
                                                                  <br></br>•
                                                                  16,15
                                                                </td>
                                                                <td>
                                                                  • 02 30
                                                                  <br></br>• 17
                                                                  45<br></br>•
                                                                  20 05<br></br>
                                                                  • 20 22
                                                                  <br></br>• 00
                                                                  03
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  space between
                                                                  the hours and
                                                                  the minutes.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Algebraic term
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    2x
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    2x
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 2<br></br>•
                                                                  2 x (with a
                                                                  space)
                                                                  <br></br>• 2xx
                                                                  <br></br>• xx
                                                                  <br></br>• x2
                                                                </td>
                                                                <td>
                                                                  • y<br></br>•
                                                                  5k<br></br>•
                                                                  10b<br></br>•
                                                                  -3p<br></br>•
                                                                  -12m
                                                                </td>
                                                                <td>
                                                                  Write 1y as y.
                                                                  <br></br>
                                                                  Make sure to
                                                                  include the
                                                                  negative sign
                                                                  “-” for
                                                                  negative
                                                                  algebraic
                                                                  terms.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Algebraic term
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    4pq
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    4pq
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 4qp<br></br>
                                                                  • pq4<br></br>
                                                                  • qp4<br></br>
                                                                  • p4q<br></br>
                                                                  • q4p
                                                                </td>
                                                                <td>
                                                                  • ab<br></br>•
                                                                  3mn<br></br>•
                                                                  -cd<br></br>•
                                                                  -5yz
                                                                </td>
                                                                <td>
                                                                  Write 1ab as
                                                                  ab.<br></br>
                                                                  Make sure to
                                                                  include the
                                                                  negative sign
                                                                  “-” for
                                                                  negative
                                                                  algebraic
                                                                  terms.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Algebraic term
                                                                  with power
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    3x²
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    3x^2
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 3x2<br></br>
                                                                  • 3xx<br></br>
                                                                  • 3x_2
                                                                  <br></br>•
                                                                  (3x)^2
                                                                </td>
                                                                <td>
                                                                  • y^2<br></br>
                                                                  • 5k^3
                                                                  <br></br>•
                                                                  10b^2<br></br>
                                                                  • -3p^2
                                                                  <br></br>•
                                                                  -12m^3
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include “^”
                                                                  for indices.
                                                                  <br></br>
                                                                  To type “^”,
                                                                  type “Shift”,
                                                                  followed by
                                                                  “6” on the
                                                                  keyboard.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Linear
                                                                  expression
                                                                  (positive
                                                                  terms only)
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    4x + 5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    4x + 5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 5 + 4x (with
                                                                  a space before
                                                                  and after the
                                                                  +)<br></br>•
                                                                  x4 + 5
                                                                  <br></br>• 5 +
                                                                  x4<br></br>•
                                                                  xxxx + 5
                                                                  <br></br>•
                                                                  xxxx5<br></br>
                                                                  • 5xxxx
                                                                </td>
                                                                <td>
                                                                  • a + 1
                                                                  <br></br>• 2h
                                                                  + 3<br></br>•
                                                                  m + 3n + 4
                                                                  <br></br>• 4p
                                                                  + 5q + 6
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  space before
                                                                  and after the
                                                                  “+” sign,
                                                                  after the
                                                                  first term.
                                                                  <br></br>
                                                                  Flag (⚐) the
                                                                  question if an
                                                                  equivalent
                                                                  expression is
                                                                  not accepted.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Linear
                                                                  expression
                                                                  (positive and
                                                                  negative
                                                                  terms) e.g.{" "}
                                                                  <span className="text-danger">
                                                                    4x - 5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    4x - 5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • -5 + 4x
                                                                  (with a space
                                                                  before and
                                                                  after the -)
                                                                  <br></br>• x4
                                                                  - 5<br></br>•
                                                                  -5 + x4
                                                                  <br></br>•
                                                                  xxxx - 5
                                                                  <br></br>•
                                                                  xxxx5<br></br>
                                                                  • 5xxxx
                                                                </td>
                                                                <td>
                                                                  • a - 1
                                                                  <br></br>• -1
                                                                  + a<br></br>•
                                                                  2h - 3
                                                                  <br></br>• -3
                                                                  + 2h<br></br>•
                                                                  m - 3n + 4
                                                                  <br></br>• 4p
                                                                  - 5q - 6
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  space before
                                                                  and after the
                                                                  “+” or “-”
                                                                  sign, after
                                                                  the first
                                                                  term.<br></br>
                                                                  Flag (⚐) the
                                                                  question if an
                                                                  equivalent
                                                                  expression is
                                                                  not accepted.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Linear
                                                                  expression
                                                                  (negative
                                                                  terms only)
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    -4x - 5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    -4x - 5
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • -5 - 4x
                                                                  <br></br>• -x4
                                                                  - 5<br></br>•
                                                                  -5 - x4
                                                                  <br></br>•
                                                                  -xxxx - 5
                                                                  <br></br>•
                                                                  -xxxx5
                                                                  <br></br>•
                                                                  -5xxxx
                                                                </td>
                                                                <td>
                                                                  • -a - 1
                                                                  <br></br>• -1
                                                                  - a<br></br>•
                                                                  -2h - 3
                                                                  <br></br>• -3
                                                                  - 2h<br></br>•
                                                                  -m - 3n - 4
                                                                  <br></br>• -4p
                                                                  - 5q - 6
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include a
                                                                  space before
                                                                  and after the
                                                                  “-” sign,
                                                                  after the
                                                                  first term.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Algebraic
                                                                  fraction e.g.{" "}
                                                                  <span className="text-danger">
                                                                    (3y)/4
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    (3y)/4
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 3y/4
                                                                  <br></br>•
                                                                  3/(4y)
                                                                  <br></br>•
                                                                  (3y/4)
                                                                  <br></br>•
                                                                  [3y]/4
                                                                </td>
                                                                <td>
                                                                  • a/4<br></br>
                                                                  • (2x)/3
                                                                  <br></br>•
                                                                  (2/3)x
                                                                  <br></br>•
                                                                  b^2/4<br></br>
                                                                  • (1/4)b^2
                                                                  <br></br>•
                                                                  (4x^2)/5
                                                                  <br></br>•
                                                                  (4/5)x^2
                                                                  <br></br>• (m
                                                                  + 3)/7
                                                                  <br></br>• (5n
                                                                  - 4)/6
                                                                </td>
                                                                <td>
                                                                  Note the
                                                                  placement of
                                                                  the round
                                                                  brackets.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Algebraic
                                                                  fraction (with
                                                                  negative term)
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    -(3y)/4
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    -(3y)/4
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • -3y/4
                                                                  <br></br>•
                                                                  -3/(4y)
                                                                  <br></br>•
                                                                  -(3y/4)
                                                                  <br></br>•
                                                                  (-3y/4)
                                                                  <br></br>•
                                                                  -[3y]/4
                                                                </td>
                                                                <td>
                                                                  • -a/4
                                                                  <br></br>•
                                                                  -(2x)/3
                                                                  <br></br>•
                                                                  (-2x)/3
                                                                  <br></br>•
                                                                  -(2/3)x
                                                                  <br></br>• -(m
                                                                  + 3)/7
                                                                  <br></br>• (-m
                                                                  - 3)/7
                                                                  <br></br>•
                                                                  -(5n - 4)/6
                                                                  <br></br>•
                                                                  (-5n + 4)/6
                                                                </td>
                                                                <td>
                                                                  Note the
                                                                  placement of
                                                                  the round
                                                                  brackets.
                                                                </td>
                                                              </tr>
                                                              <tr className="align-middle">
                                                                <td>
                                                                  Quadratic
                                                                  expression
                                                                  e.g.{" "}
                                                                  <span className="text-danger">
                                                                    5x^2 + 7
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  <span className="text-danger">
                                                                    5x^2 + 7
                                                                  </span>
                                                                </td>
                                                                <td>
                                                                  • 5x2 + 7
                                                                  <br></br>• 7 +
                                                                  5x2<br></br>•
                                                                  x^25 + 7
                                                                  <br></br>• 7 +
                                                                  x^25
                                                                </td>
                                                                <td>
                                                                  • y^2 + 4
                                                                  <br></br>• 4 +
                                                                  y^2<br></br>•
                                                                  k^2 - 5
                                                                  <br></br>• -5
                                                                  + k^2<br></br>
                                                                  • 4m^2 - 3
                                                                  <br></br>• -3
                                                                  + 4m^2
                                                                  <br></br>• x^2
                                                                  + 3x - 1
                                                                  <br></br>•
                                                                  2n^2 - 5n + 4
                                                                </td>
                                                                <td>
                                                                  Make sure to
                                                                  include “^”
                                                                  for the
                                                                  quadratic
                                                                  term.<br></br>
                                                                  Make sure to
                                                                  include a
                                                                  space before
                                                                  and after the
                                                                  “+” or “-”
                                                                  sign, after
                                                                  the first
                                                                  term.
                                                                </td>
                                                              </tr>
                                                            </tbody>
                                                          </Table>
                                                        </AccordionBody>
                                                      </AccordionItem>
                                                    </Accordion>
                                                  </PopoverBody>
                                                </UncontrolledPopover>
                                              </div>
                                             {parseInt(customActiveTab) === activeindex + 1 && renderOverlayToggle()}
                                            </div>

                                            <div className="d-flex gap-3">
                                              {InnerActivityData?.question_text && renderSpeakerToggle("q" + index, [
                                                InnerActivityData?.question_text
                                              ])}
                                              <div
                                                className="mt-4"
                                                dangerouslySetInnerHTML={{
                                                  __html:
                                                    InnerActivityData.question_text
                                                      ? InnerActivityData.question_text
                                                          .replace(
                                                            /\[(\d+)Answer char=\d+\]/g,
                                                            ""
                                                          )
                                                          .replace(
                                                            /\[Answer char=\d+\]/g,
                                                            ""
                                                          )
                                                      : null,
                                                }}
                                              ></div>
                                            </div>

                                            {/* Past question */}
                                            {InnerActivityData.question_parts &&
                                              InnerActivityData.question_parts.map(
                                                (quspart, index) => {
                                                  const stuAnswersarray =
                                                    quspart.StudentAnsAttempts.map(
                                                      stuAns => {
                                                        try {
                                                          return JSON.parse(
                                                            stuAns.student_answer
                                                          )
                                                        } catch (error) {
                                                          console.error(
                                                            "Error parsing JSON:",
                                                            error
                                                          )
                                                          return null // or handle the error in an appropriate way
                                                        }
                                                      }
                                                    ) || [] // Extracting session keys

                                                  // Assuming stuAnswersarray is a nested array
                                                  const flattenedStuAnswers =
                                                    [].concat(
                                                      ...stuAnswersarray
                                                    )
                                                  let serialNumber = 0
                                                  return (
                                                    <div key={index}>
                                                      <div class="d-flex justify-content-between gap-3 mb-3">
                                                        <div className="d-flex gap-2 flex-row ">
                                                          {quspart?.part_text && renderSpeakerToggle("pt" + index, [
                                                            quspart?.part_text,
                                                          ])}
                                                          <div className="mr-3">
                                                            {index + 1}
                                                            {")"}
                                                          </div>
                                                          <div
                                                            dangerouslySetInnerHTML={{
                                                              __html:
                                                                quspart.part_text
                                                                  ? quspart.part_text
                                                                      .replace(
                                                                        /\[(\d+)Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                      .replace(
                                                                        /\[Answer char=\d+\]/g,
                                                                        ""
                                                                      )
                                                                  : null,
                                                            }}
                                                          ></div>
                                                        </div>
                                                        {quspart
                                                          .StudentAnsAttempts
                                                          .length > 0 ? (
                                                          quspart.markedReport &&
                                                          quspart.markedReport >
                                                            0 ? (
                                                            <div>
                                                              {/* <span className="text-success"><i className="mdi mdi-clipboard-check-outline font-size-18"></i></span> */}
                                                              <span className="badge bg-warning font-size-12 mt-auto mb-2">
                                                                Override
                                                              </span>
                                                            </div>
                                                          ) : (
                                                            <div>
                                                              <i
                                                                id={`Popover_mark_override_${quspart.part_id}`}
                                                                className="mdi mdi-clipboard-check-outline font-size-18"
                                                                onClick={() =>
                                                                  tog_passcode(
                                                                    ActivityData1,
                                                                    quspart
                                                                  )
                                                                }
                                                              ></i>
                                                              {/* Popover */}
                                                              {authTutorUser && (
                                                                <UncontrolledPopover
                                                                  //placement="bottom"
                                                                  trigger="legacy"
                                                                  target={`Popover_mark_override_${quspart.part_id}`} // Matches button ID
                                                                  isOpen={
                                                                    activePopoverId ===
                                                                    quspart.part_id
                                                                  } // Only open the popover if its ID matches the active one
                                                                  toggle={() =>
                                                                    togglePopover(
                                                                      quspart.part_id
                                                                    )
                                                                  } // Toggle popover visibility
                                                                  onClosed={() =>
                                                                    console.log(
                                                                      "close"
                                                                    )
                                                                  } // Custom function when popover is closed
                                                                >
                                                                  <PopoverBody
                                                                    className="shadow rounded bg-white p-3"
                                                                    style={{
                                                                      width:
                                                                        "300px",
                                                                    }}
                                                                  >
                                                                    <p>
                                                                      <strong>
                                                                        Is the
                                                                        student
                                                                        answer
                                                                        correct?
                                                                      </strong>
                                                                    </p>
                                                                    {/* Yes / No Checkboxes */}
                                                                    <div className="d-flex justify-content-around my-2">
                                                                      <label
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                      >
                                                                        <input
                                                                          type="radio"
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                          name={`correct_${quspart.part_id}`}
                                                                          value="1"
                                                                          checked={
                                                                            selectedOption ==
                                                                            "1"
                                                                          }
                                                                          onChange={() => {
                                                                            if (
                                                                              quspart.StudentAnsAttempts.every(
                                                                                attempt =>
                                                                                  attempt.attempt_status ===
                                                                                  1
                                                                              )
                                                                            ) {
                                                                              toast.error(
                                                                                "Already status correct",
                                                                                {
                                                                                  autoClose: 3000, // 3 seconds in this example
                                                                                }
                                                                              )
                                                                            } else {
                                                                              setSelectedOption(
                                                                                "1"
                                                                              )
                                                                              setError(
                                                                                false
                                                                              )
                                                                            }
                                                                          }}
                                                                        />{" "}
                                                                        Yes
                                                                      </label>
                                                                      <label
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                        }}
                                                                      >
                                                                        <input
                                                                          type="radio"
                                                                          style={{
                                                                            cursor:
                                                                              "pointer",
                                                                          }}
                                                                          name={`correct_${quspart.part_id}`}
                                                                          value="0"
                                                                          checked={
                                                                            selectedOption ==
                                                                            "0"
                                                                          }
                                                                          onChange={() => {
                                                                            if (
                                                                              quspart.StudentAnsAttempts.every(
                                                                                attempt =>
                                                                                  attempt.attempt_status ===
                                                                                  0
                                                                              )
                                                                            ) {
                                                                              toast.error(
                                                                                "Already status incorrect",
                                                                                {
                                                                                  autoClose: 3000, // 3 seconds in this example
                                                                                }
                                                                              )
                                                                            } else {
                                                                              setSelectedOption(
                                                                                "0"
                                                                              )
                                                                              setError(
                                                                                false
                                                                              )
                                                                            }
                                                                          }}
                                                                          // disabled={}
                                                                        />{" "}
                                                                        No
                                                                      </label>
                                                                    </div>
                                                                    {/* Error message if checkbox is not selected */}
                                                                    {error && (
                                                                      <p className="text-danger text-center">
                                                                        Please
                                                                        select
                                                                        Yes or
                                                                        No
                                                                      </p>
                                                                    )}
                                                                    {(selectedOption ==
                                                                      "1" ||
                                                                      selectedOption ==
                                                                        "0") && (
                                                                      <div className="student-answers mt-3">
                                                                        <h5>
                                                                          Student
                                                                          Answers:
                                                                        </h5>
                                                                        {quspart.part_answer_type ===
                                                                        2 ? (
                                                                          <ul className="dg-selector width-controll list-unstyled mb-0">
                                                                            {quspart.question_answers &&
                                                                              quspart.question_answers.map(
                                                                                (
                                                                                  qusAns,
                                                                                  index1
                                                                                ) => {
                                                                                  const stuAnswersarray =
                                                                                    quspart.StudentAnsAttempts.filter(
                                                                                      stuAns => {
                                                                                        const attemptStatus =
                                                                                          parseInt(
                                                                                            stuAns.attempt_status
                                                                                          )
                                                                                        return selectedOption ===
                                                                                          "1"
                                                                                          ? attemptStatus ===
                                                                                              0
                                                                                          : attemptStatus ===
                                                                                              1
                                                                                      }
                                                                                    ).flatMap(
                                                                                      stuAns => {
                                                                                        try {
                                                                                          const parsedAnswers =
                                                                                            JSON.parse(
                                                                                              stuAns.student_answer
                                                                                            )
                                                                                          return parsedAnswers.map(
                                                                                            ans => ({
                                                                                              ...ans,
                                                                                              pk_attempt_id:
                                                                                                stuAns.pk_attempt_id,
                                                                                            })
                                                                                          )
                                                                                        } catch (error) {
                                                                                          console.error(
                                                                                            "Error parsing JSON:",
                                                                                            error
                                                                                          )
                                                                                          return null // or handle the error in an appropriate way
                                                                                        }
                                                                                      }
                                                                                    ) ||
                                                                                    []
                                                                                  const flattenedStuAnswers =
                                                                                    [].concat(
                                                                                      ...stuAnswersarray
                                                                                    )

                                                                                  if (
                                                                                    qusAns.answer_is_correct ===
                                                                                    1
                                                                                  ) {
                                                                                    let filteredAllStuAns =
                                                                                      flattenedStuAnswers.filter(
                                                                                        stuAns =>
                                                                                          parseInt(
                                                                                            stuAns.part_id
                                                                                          ) ===
                                                                                            parseInt(
                                                                                              qusAns.answer_part_id
                                                                                            ) &&
                                                                                          parseInt(
                                                                                            stuAns.answer_id
                                                                                          ) ===
                                                                                            parseInt(
                                                                                              qusAns.answer_id
                                                                                            )
                                                                                      ) ||
                                                                                      []

                                                                                    return (
                                                                                      <div
                                                                                        key={
                                                                                          index1
                                                                                        }
                                                                                        className="student-answers mt-3"
                                                                                      >
                                                                                        <ul className="list-group">
                                                                                          {filteredAllStuAns
                                                                                            .reverse()
                                                                                            .map(
                                                                                              (
                                                                                                item,
                                                                                                idx
                                                                                              ) => (
                                                                                                <>
                                                                                                  <li
                                                                                                    className="list-group-item align-items-center gap-1 ps-2 mb-2"
                                                                                                    key={`${idx}_answer${item.pk_attempt_id}`}
                                                                                                    onClick={() => {
                                                                                                      setSelectedStudentAnswer(
                                                                                                        item.answer_id
                                                                                                      )
                                                                                                      setSelectedAttemptId(
                                                                                                        item.pk_attempt_id
                                                                                                      )
                                                                                                      setansError(
                                                                                                        false
                                                                                                      )
                                                                                                      console.log(
                                                                                                        item
                                                                                                      )
                                                                                                    }}
                                                                                                    style={{
                                                                                                      cursor:
                                                                                                        "pointer",
                                                                                                    }}
                                                                                                  >
                                                                                                    <div className="d-flex align-items-center gap-1">
                                                                                                      <input
                                                                                                        type="radio"
                                                                                                        name={`selected_answer_${idx}${item.pk_attempt_id}`}
                                                                                                        value={
                                                                                                          item.answer_id
                                                                                                        }
                                                                                                        checked={
                                                                                                          selectedAttemptId ===
                                                                                                          item.pk_attempt_id
                                                                                                        }
                                                                                                        onClick={() => {
                                                                                                          setSelectedStudentAnswer(
                                                                                                            item.answer_id
                                                                                                          )
                                                                                                          setSelectedAttemptId(
                                                                                                            item.pk_attempt_id
                                                                                                          )
                                                                                                          setansError(
                                                                                                            false
                                                                                                          )
                                                                                                        }}
                                                                                                      />
                                                                                                      {
                                                                                                        item.text
                                                                                                      }
                                                                                                    </div>
                                                                                                  </li>
                                                                                                </>
                                                                                              )
                                                                                            )}
                                                                                        </ul>
                                                                                      </div>
                                                                                    )
                                                                                  }
                                                                                }
                                                                              )}
                                                                          </ul>
                                                                        ) : quspart.part_answer_type ===
                                                                          4 ? (
                                                                          //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                                          <ul className="list-group">
                                                                            {quspart
                                                                              .StudentAnsAttempts
                                                                              .length >
                                                                            0 ? (
                                                                              quspart.StudentAnsAttempts.filter(
                                                                                stuAns => {
                                                                                  const attemptStatus =
                                                                                    parseInt(
                                                                                      stuAns.attempt_status
                                                                                    )
                                                                                  return selectedOption ===
                                                                                    "1"
                                                                                    ? attemptStatus ===
                                                                                        0
                                                                                    : attemptStatus ===
                                                                                        1
                                                                                }
                                                                              ).map(
                                                                                (
                                                                                  stuAns,
                                                                                  index
                                                                                ) => {
                                                                                  const studentAnswer =
                                                                                    JSON.parse(
                                                                                      stuAns.student_answer
                                                                                    )
                                                                                  const flatStuAnswers =
                                                                                    [].concat(
                                                                                      ...studentAnswer
                                                                                    )

                                                                                  const filterStuAns =
                                                                                    flatStuAnswers.filter(
                                                                                      stuAns =>
                                                                                        quspart?.question_answers?.some(
                                                                                          answer =>
                                                                                            parseInt(
                                                                                              stuAns.part_id
                                                                                            ) ===
                                                                                              parseInt(
                                                                                                answer.answer_part_id
                                                                                              ) &&
                                                                                            parseInt(
                                                                                              stuAns.answer_id
                                                                                            ) ===
                                                                                              parseInt(
                                                                                                answer.answer_id
                                                                                              )
                                                                                        )
                                                                                    ) ||
                                                                                    []

                                                                                  return filterStuAns.length >
                                                                                    0
                                                                                    ? filterStuAns.map(
                                                                                        (
                                                                                          filteredAns,
                                                                                          filteredIndex
                                                                                        ) => {
                                                                                          return (
                                                                                            <>
                                                                                              <li
                                                                                                className="list-group-item"
                                                                                                key={`${index}_${filteredIndex}`}
                                                                                              >
                                                                                                <div
                                                                                                  className="d-flex align-items-center gap-1"
                                                                                                  onClick={() => {
                                                                                                    setSelectedStudentAnswer(
                                                                                                      filteredAns.answer_id
                                                                                                    )
                                                                                                    setSelectedAttemptId(
                                                                                                      stuAns.pk_attempt_id
                                                                                                    )
                                                                                                    setansError(
                                                                                                      false
                                                                                                    )
                                                                                                  }}
                                                                                                  style={{
                                                                                                    cursor:
                                                                                                      "pointer",
                                                                                                  }}
                                                                                                >
                                                                                                  {/* Allow user to select the answer */}
                                                                                                  <input
                                                                                                    type="radio"
                                                                                                    name={`selected_answer_${index}`}
                                                                                                    value={
                                                                                                      filteredAns.answer_id
                                                                                                    }
                                                                                                    checked={
                                                                                                      selectedStudentAnswer ===
                                                                                                      filteredAns.answer_id
                                                                                                    }
                                                                                                    onChange={() => {
                                                                                                      setSelectedStudentAnswer(
                                                                                                        filteredAns.answer_id
                                                                                                      )
                                                                                                      setSelectedAttemptId(
                                                                                                        stuAns.pk_attempt_id
                                                                                                      )
                                                                                                      setansError(
                                                                                                        false
                                                                                                      )
                                                                                                    }}
                                                                                                  />
                                                                                                  <div
                                                                                                    dangerouslySetInnerHTML={{
                                                                                                      __html:
                                                                                                        filteredAns.text ||
                                                                                                        "No answer provided",
                                                                                                    }}
                                                                                                  ></div>
                                                                                                </div>
                                                                                              </li>
                                                                                            </>
                                                                                          )
                                                                                        }
                                                                                      )
                                                                                    : null
                                                                                }
                                                                              )
                                                                            ) : (
                                                                              <li className="list-group-item">
                                                                                No
                                                                                student
                                                                                answers
                                                                                available
                                                                              </li>
                                                                            )}
                                                                          </ul>
                                                                        ) : (
                                                                          <p className="text-center">
                                                                            No
                                                                            option
                                                                          </p>
                                                                        )}
                                                                        {anserror && (
                                                                          <p className="text-danger text-center">
                                                                            Please
                                                                            select
                                                                            the
                                                                            correct
                                                                            answer
                                                                          </p>
                                                                        )}
                                                                      </div>
                                                                    )}
                                                                    {/* Feedback Textarea */}
                                                                    <textarea
                                                                      className="form-control my-2"
                                                                      placeholder="Enter feedback..."
                                                                      value={
                                                                        feedback
                                                                      }
                                                                      onChange={e =>
                                                                        setFeedback(
                                                                          e
                                                                            .target
                                                                            .value
                                                                        )
                                                                      }
                                                                    ></textarea>

                                                                    {/* Buttons */}
                                                                    <div className="d-flex justify-content-between mt-3">
                                                                      <button
                                                                        className="btn btn-secondary btn-sm"
                                                                        onClick={() =>
                                                                          setActivePopoverId(
                                                                            null
                                                                          )
                                                                        }
                                                                      >
                                                                        Cancel
                                                                      </button>
                                                                      <button
                                                                        className="btn btn-primary btn-sm"
                                                                        onClick={
                                                                          handleSubmit
                                                                        }
                                                                      >
                                                                        Submit
                                                                      </button>
                                                                    </div>
                                                                  </PopoverBody>
                                                                </UncontrolledPopover>
                                                              )}
                                                            </div>
                                                          )
                                                        ) : null}
                                                      </div>
                                                      {/* Anse category statement Star */}
                                                      {quspart.part_answer_type ===
                                                      2 ? (
                                                        <ul className="dg-selector width-controll list-unstyled mb-0">
                                                          {quspart.question_answers &&
                                                            quspart.question_answers.map(
                                                              (
                                                                qusAns,
                                                                index1
                                                              ) => {
                                                                if (
                                                                  quspart
                                                                    .StudentAnsAttempts
                                                                    .length > 0
                                                                ) {
                                                                  return quspart.StudentAnsAttempts.map(
                                                                    (
                                                                      qusStuAns,
                                                                      stuAnsindex
                                                                    ) => {
                                                                      // Your logic for filtering student answers and determining status_color and border_color
                                                                      const stuAnswersarray =
                                                                        quspart.StudentAnsAttempts.filter(
                                                                          stuAns =>
                                                                            stuAns.atempt_count ===
                                                                            stuAnsindex +
                                                                              1
                                                                        ).map(
                                                                          stuAns => {
                                                                            try {
                                                                              return JSON.parse(
                                                                                stuAns.student_answer
                                                                              )
                                                                            } catch (error) {
                                                                              console.error(
                                                                                "Error parsing JSON:",
                                                                                error
                                                                              )
                                                                              return null // or handle the error in an appropriate way
                                                                            }
                                                                          }
                                                                        ) || []

                                                                      //console.log(stuAnswersarray);
                                                                      // Assuming stuAnswersarray is a nested array
                                                                      const flattenedStuAnswers =
                                                                        [].concat(
                                                                          ...stuAnswersarray
                                                                        )
                                                                      //  let cleanedText = qusAns.answer_text.replace(/&nbsp;/g, '').replace(/`/g, '').replace(/<[^>]*>/g, '') || '';
                                                                      //  let resultTest = cleanedText.toLowerCase().trim();
                                                                      //  let answers = resultTest.split('|') || [];
                                                                      //  let firstAnswer = answers[0] ? answers[0].trim() : "";
                                                                      //  let secondAnswer = answers[1] ? answers[1].trim() : "";

                                                                      if (
                                                                        qusAns.answer_is_correct ===
                                                                        1
                                                                      ) {
                                                                        let filteredStuAns =
                                                                          flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                              parseInt(
                                                                                stuAns.part_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_part_id
                                                                                ) &&
                                                                              parseInt(
                                                                                qusStuAns.attempt_status
                                                                              ) ===
                                                                                1 &&
                                                                              parseInt(
                                                                                stuAns.answer_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_id
                                                                                )
                                                                          ) ||
                                                                          []

                                                                        let filteredAllStuAns =
                                                                          flattenedStuAnswers.filter(
                                                                            stuAns =>
                                                                              parseInt(
                                                                                stuAns.part_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_part_id
                                                                                ) &&
                                                                              parseInt(
                                                                                stuAns.answer_id
                                                                              ) ===
                                                                                parseInt(
                                                                                  qusAns.answer_id
                                                                                )
                                                                          ) ||
                                                                          []

                                                                        return (
                                                                          <li
                                                                            key={
                                                                              index1
                                                                            }
                                                                            className={
                                                                              filteredStuAns.length >
                                                                              0
                                                                                ? " input_box m_input_box"
                                                                                : "input_box m_input_box"
                                                                            }
                                                                          >
                                                                            <input
                                                                              id={
                                                                                index1 +
                                                                                Math.floor(
                                                                                  Math.random() *
                                                                                    5
                                                                                )
                                                                              }
                                                                              type="text"
                                                                              className={
                                                                                parseInt(
                                                                                  qusStuAns.attempt_status
                                                                                ) ===
                                                                                1
                                                                                  ? "answersuccess"
                                                                                  : "answererror"
                                                                              }
                                                                              value={
                                                                                filteredAllStuAns
                                                                                  .filter(
                                                                                    item =>
                                                                                      parseInt(
                                                                                        item.answer_id
                                                                                      ) ===
                                                                                      parseInt(
                                                                                        qusAns.answer_id
                                                                                      )
                                                                                  )
                                                                                  .map(
                                                                                    item =>
                                                                                      item.text
                                                                                  )
                                                                                  .find(
                                                                                    text =>
                                                                                      text !==
                                                                                      undefined
                                                                                  ) ||
                                                                                "" // Find the first non-undefined text value
                                                                              }
                                                                              disabled={
                                                                                true
                                                                              }
                                                                              //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                              onChange={e =>
                                                                                handletext(
                                                                                  e,
                                                                                  qusAns.answer_id,
                                                                                  qusAns.answer_part_id
                                                                                )
                                                                              }
                                                                              // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                            />
                                                                          </li>
                                                                        )
                                                                      }
                                                                    }
                                                                  )
                                                                } else {
                                                                  return (
                                                                    <li
                                                                      key={
                                                                        index1
                                                                      }
                                                                      className={
                                                                        "input_box m_input_box"
                                                                      }
                                                                    >
                                                                      <input
                                                                        id={
                                                                          index1 +
                                                                          Math.floor(
                                                                            Math.random() *
                                                                              5
                                                                          )
                                                                        }
                                                                        type="text"
                                                                        className={
                                                                          "answereditor"
                                                                        }
                                                                        value={
                                                                          "" // Find the first non-undefined text value
                                                                        }
                                                                        disabled={
                                                                          true
                                                                        }
                                                                        //onKeyUp={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                        //onChange={(e) => handletext(e, qusAns.answer_id, qusAns.answer_part_id)}
                                                                        // onBlur={(e) => handletext(e, qusAns.english_answer_id, qusAns.english_answer_part_id)}
                                                                      />
                                                                    </li>
                                                                  )
                                                                }
                                                              }
                                                            )}
                                                        </ul>
                                                      ) : quspart.part_answer_type ===
                                                        4 ? (
                                                        //const stuAnswersarray = stuAnswersJson.length > 0 ? JSON.parse(stuAnswersJson) : [];
                                                        <ul className="dg-selector choose-it-question  width-controll list-unstyled mb-0">
                                                          {quspart.question_answers &&
                                                            rearrangeEvenOdd(
                                                              quspart.question_answers
                                                            ).map(
                                                              (
                                                                qusAns,
                                                                index1
                                                              ) => {
                                                                const cleanText =
                                                                  qusAns.answer_text
                                                                    .replace(
                                                                      /&nbsp;/g,
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      /`/g,
                                                                      ""
                                                                    )
                                                                    .replace(
                                                                      /<[^>]*>/g,
                                                                      ""
                                                                    )
                                                                    .trim()

                                                                const hasImage =
                                                                  /<img\s+[^>]*>/gi.test(
                                                                    qusAns.answer_text
                                                                  )

                                                                if (
                                                                  !cleanText &&
                                                                  !hasImage
                                                                ) {
                                                                  return null // Skip rendering if english_answer_text is effectively empty and no image is present
                                                                }
                                                                serialNumber++
                                                                let filteredStuAns =
                                                                  flattenedStuAnswers.filter(
                                                                    stuAns =>
                                                                      parseInt(
                                                                        stuAns.part_id
                                                                      ) ===
                                                                        parseInt(
                                                                          qusAns.answer_part_id
                                                                        ) &&
                                                                      parseInt(
                                                                        stuAns.answer_id
                                                                      ) ===
                                                                        parseInt(
                                                                          qusAns.answer_id
                                                                        )
                                                                  ) || []

                                                                //OverRide check status start
                                                                let filteredStuAnsoverridedata =
                                                                  quspart.StudentAnsAttempts.filter(
                                                                    stuAns =>
                                                                      parseInt(
                                                                        stuAns.attempt_status
                                                                      ) === 1
                                                                  ) || []
                                                                const stuAnswersoverridearray =
                                                                  filteredStuAnsoverridedata.map(
                                                                    stuAns => {
                                                                      try {
                                                                        return JSON.parse(
                                                                          stuAns.student_answer
                                                                        )
                                                                      } catch (error) {
                                                                        console.error(
                                                                          "Error parsing JSON:",
                                                                          error
                                                                        )
                                                                        return null // or handle the error in an appropriate way
                                                                      }
                                                                    }
                                                                  ) || []
                                                                const flattenedoverrideStuAnswers =
                                                                  [].concat(
                                                                    ...stuAnswersoverridearray
                                                                  )

                                                                let filteredStuAnsoverride =
                                                                  flattenedoverrideStuAnswers.filter(
                                                                    stuAns =>
                                                                      parseInt(
                                                                        stuAns.part_id
                                                                      ) ===
                                                                        parseInt(
                                                                          qusAns.answer_part_id
                                                                        ) &&
                                                                      parseInt(
                                                                        stuAns.answer_id
                                                                      ) ===
                                                                        parseInt(
                                                                          qusAns.answer_id
                                                                        )
                                                                  ) || []

                                                                //OverRide check status end

                                                                var status_color =
                                                                  "selector-general cursor-pointer"
                                                                var border_color =
                                                                  "border-start-secondary"
                                                                if (
                                                                  filteredStuAns.length >
                                                                  0
                                                                ) {
                                                                  if (
                                                                    parseInt(
                                                                      qusAns.answer_is_correct
                                                                    ) === 1 &&
                                                                    !quspart?.markedReport >
                                                                      0
                                                                  ) {
                                                                    status_color =
                                                                      "selector-success"
                                                                    border_color =
                                                                      "border-start-success"
                                                                  } else if (
                                                                    filteredStuAnsoverride.length >
                                                                      0 &&
                                                                    quspart.markedReport >
                                                                      0
                                                                  ) {
                                                                    status_color =
                                                                      "selector-success"
                                                                    border_color =
                                                                      "border-start-success"
                                                                  } else {
                                                                    status_color =
                                                                      "selector-wrong "
                                                                    border_color =
                                                                      "border-start-danger"
                                                                  }
                                                                }
                                                                //const sesKeys = quspart.StudentAnsAttempts.map(stuAns => stuAns.part_id); // Extracting session keys
                                                                return (
                                                                  <li
                                                                    className={
                                                                      status_color +
                                                                      " choose m_choose"
                                                                    }
                                                                    key={index1}
                                                                  >
                                                                    <div
                                                                      style={{
                                                                        position: "absolute",
                                                                        left: "-40px",
                                                                        top: "50%",
                                                                        transform: "translateY(-50%)",
                                                                      }}
                                                                      onClick={e => e.stopPropagation()}
                                                                    >
                                                                      {renderSpeakerToggle(
                                                                        "ans-" + qusAns.answer_id,
                                                                        [qusAns.answer_text]
                                                                      )}
                                                                    </div>
                                                                    <div className="p-2 px-3 font-size-18 dg-serial-badge-wrap">
                                                                      <span className="dg-serial-badge">{serialNumber}</span>
                                                                    </div>
                                                                    <div
                                                                      className={
                                                                        "p-2 dg-media " +
                                                                        {
                                                                          border_color,
                                                                        }
                                                                      }
                                                                      dangerouslySetInnerHTML={{
                                                                        __html:
                                                                          qusAns.answer_text
                                                                            ? qusAns.answer_text
                                                                            : null,
                                                                      }}
                                                                    ></div>
                                                                  </li>
                                                                )
                                                              }
                                                            )}
                                                        </ul>
                                                      ) : (
                                                        <p className="text-center">
                                                          No option
                                                        </p>
                                                      )}
                                                      {/* Anse category statement end */}
                                                    </div>
                                                  )
                                                }
                                              )}
                                            <>
                                              {InnerActivityData.question_parts &&
                                                InnerActivityData.question_parts.map(
                                                  (quspart, index) => {
                                                    let filteredAns = []
                                                    if (
                                                      quspart.StudentQusSkip
                                                        .length === 0
                                                    ) {
                                                      filteredAns =
                                                        quspart.question_answers.filter(
                                                          CorrAns =>
                                                            parseInt(
                                                              CorrAns.answer_is_correct
                                                            ) === 1
                                                        )
                                                    }

                                                    return filteredAns.map(
                                                      (qusAns, feedindex1) => {
                                                        return (
                                                          <>
                                                            {feedindex1 ===
                                                            0 ? (
                                                              <h4 className="font-size-16 fw-bold mb-2 mt-3">
                                                                Solution
                                                              </h4>
                                                            ) : null}

                                                            <div
                                                              className="m_feedBack"
                                                              style={{
                                                                border:
                                                                  "1px solid #1a1a1a",
                                                                borderRadius:
                                                                  "4px",
                                                                fontSize:
                                                                  "16px",
                                                              }}
                                                            >
                                                              {/* <div className="p-2 px-3 font-size-18">{feedindex1 + 1}</div> */}
                                                              <div
                                                                dangerouslySetInnerHTML={{
                                                                  __html:
                                                                    qusAns.answer_text
                                                                      ? qusAns.answer_text
                                                                      : null,
                                                                }}
                                                              ></div>
                                                            </div>
                                                          </>
                                                        )
                                                      }
                                                    )
                                                  }
                                                )}
                                            </>
                                          </li>
                                        </ul>
                                        <div className={'action-btns d-flex gap-4 mt-2' + (activeindex + 1 > 1 ? ' justify-content-between' : ' justify-content-end')}>
                                          {/* Render a "Prev" button if the active index is greater than 0 */}
                                          {activeindex + 1 > 1 ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(activeindex)
                                              }}
                                            >
                                              Prev
                                            </Button>
                                          ) : null}

                                          {/* Render a "Next" button if the active index is less than the total length of LessonActivitiesQuestions array */}
                                          {activeindex + 1 <
                                          ActivityData.LessonActivitiesQuestions
                                            .length ? (
                                            <Button
                                              className="btn btn-danger cs-btn-danger mt-1 assessment-nav-btn"
                                              onClick={() => {
                                                toggleCustom(
                                                  activeindex + 1 + 1
                                                )
                                              }}
                                            >
                                              Next
                                            </Button>
                                          ) : null}
                                        </div>
                                      </div>
                                    </TabPane>
                                  )
                                } else {
                                  return (
                                    <p className="text-center">No question</p>
                                  )
                                }
                              }
                            }
                          )
                        }
                      }
                    )
                  : null}
              </TabContent>

              {/* <Comprehension triggerFunction={handleFunctionTrigger} triggerSubmitFunction={handleSubmitFunction} data={ActiviteQAData} part={ActivityPart} responceData={submitOtherData} key={activityKey}/> */}
            </div>
          </Container>
        </div>
      </MathJax>
    </React.Fragment>
  )
})

export default AssessmentDetails
